// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/ArbFONTS-Janna-LT-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./ArbFONTS-Janna-LT-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../public/arrow.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../public/plus.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../public/minus.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./fonts/Nunito-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./Nunito-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --main-color: #0F1535;
  --green-color: #d76420 ;
  /* 713b14 */
  --gray-color: #FFFFFF;
  --body-color: #F1F5F9;
  --text-color: #0D6EFD;
  --sub-color: #222;
  --basic-color: #fff;
  --highlight-color: #F2205B;
  --highlight-green: #7ba946;
  --highlight-blue: #2858b4;
  --text-lighter: #333;
  --btn1-color: linear-gradient(90deg, #8824C2 0%, #F00488 100%);
  --btn2-color: linear-gradient(90deg, #FF6A00 0%, #F01414 100%);
  --input-bg: #dddddd40;
  --border-color: #cccccc;
  --shadow-light: 0px 4px 15px rgba(0, 0, 0, 0.05);
  --dropdown-bg: #fafafa;
  --top-nav: #d76420;
  --green-transparent: #713b14;
  --sidenav-width: 250px;
}

body.dark-theme {
  --main-color: #E2E8F0;
  --green-color: #d76420;
  --gray-color: #1E293B;
  --body-color: #181d2a;
  --text-color: #38BDF8;
  --sub-color: #F8FAFC;
  --basic-color: #1E293B;
  --highlight-color: #F43F5E;
  --highlight-green: #4ADE80;
  --highlight-blue: #60A5FA;
  --text-lighter: #CBD5E1;
  --text-gray: #94A3B8;
  --input-bg: #334155;
  --border-color: #475569;
  --shadow-light: 0px 4px 20px rgba(0, 0, 0, 0.4);
  --dropdown-bg: #334155;
  --top-nav: #1E293B;
  --green-transparent: rgba(16, 185, 129, 0.2);
  
  /* Bootstrap Overrides */
  --bs-body-color: var(--text-lighter);
  --bs-heading-color: var(--text-lighter);
  color: var(--text-lighter) !important;
}

body.dark-theme .text-muted {
  color: #94A3B8 !important;
}

body {
  transition: background-color 0.3s ease, color 0.3s ease;
  overflow-x: hidden;
}


@font-face {
  font-family: 'Janna';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2'),
       url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
  font-display: swap;
  font-weight: 400;
  font-style: normal;
}

::selection {
  background-color: var(--green-color);
  color: var(--basic-color);
}

body::-webkit-scrollbar {
  width: 10px;
}

body::-webkit-scrollbar-track {
  background: var(--basic-color);
}

body::-webkit-scrollbar-thumb {
  background-color: #ccc;
  border-radius: 20px;
  border: 1px solid #ddd;
}

body {
  margin: 0;
  font-family: "Janna", sans-serif !important;
  position: relative;
  text-align: right !important;
  background-color: var(--body-color) !important;
  color: var(--text-lighter);
}

/* custom */
.en-lang {
  font-family: 'Nunito',sans-serif !important;
  font-weight: bold !important;
}
.custom-font {font-family: 'janna',sans-serif !important;}
button,
a {
  cursor: pointer;
}

/* Global: show_all matches Bootstrap btn-warning */
.show_all,
.btn.show_all,
button.show_all {
  background-color: var(--bs-warning, #ffc107) !important;
  border-color: var(--bs-warning, #ffc107) !important;
  color: #000 !important;
}

.show_all:hover,
.btn.show_all:hover,
button.show_all:hover,
.show_all:focus,
.btn.show_all:focus,
button.show_all:focus {
  background-color: #ffca2c !important;
  border-color: #ffc720 !important;
  color: #000 !important;
}

.show_all:disabled,
.btn.show_all:disabled,
button.show_all:disabled {
  background-color: var(--bs-warning, #ffc107) !important;
  border-color: var(--bs-warning, #ffc107) !important;
  color: #000 !important;
  opacity: 0.65;
}

button:focus,
a:focus {
  outline: none;
}

button:active,
button:focus-visible,
button:focus-within,
button:focus,
button:target {
  border: none;
}

a {
  text-decoration: none !important;
}

.text-color {
  color: var(--text-color) !important;
}
.main-color {
  color: var(--green-color) !important;
}

.sub-text {
  color: var(--sub-color) !important;
}

.text-lighter {
  color: var(--text-lighter) !important;
}

.highlight-text {
  color: var(--highlight-color) !important;
}
.highlight-green {color: var(--highlight-green) !important;}
.highlight-blue {color: var(--highlight-blue) !important;}
.text-gray {
  color: var(--text-gray, #777);
}
.border-lighter {border: 1px solid #ffffff1f !important;}
.text-lg {
  font-size: large;
}

.text-md {
  font-size: medium;
}

.text-sm {
  font-size: small;
}

.text-xs {
  font-size: x-small;
}
.text-custom {font-size: 12px;font-weight: bold;}
.line-height {
  line-height: 1.7em;
}

.b25 {
  border-radius: 25px !important;
}
.div-bg {background-color: var(--basic-color);}
.input-bg {
  background-color: var(--input-bg) !important;
  color: var(--sub-color) !important;
  border-color: var(--border-color) !important;
}
select {
  cursor: pointer;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) !important;
  background-repeat: no-repeat;
  background-size: 10px 10px;
  border-radius: 5px;
  background-position: left 14px center !important;
  /* color: #ffffff80 !important; */
}
.file-input {overflow: hidden;position: relative;}
.file-input__input {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
  width: 100%;
}

.file-input__label {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  color: var(--basic-color);
  font-size: 14px;
  padding: 10px 12px;
  background-color: var(--green-transparent);
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.25);
  color: var(--green-color);
  border: 1px solid var(--green-color);
}
.file_wrapper {
  position: relative;
    background-color: var(--basic-color);
    border: 2px solid var(--green-color);
    border-radius: 5px;
    width: 200px;
    height: 50px;
    text-align: center;
    overflow: hidden;
    cursor: pointer;
    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, .2);
}
.file_wrapper input {
  background-color: aliceblue;
  opacity: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 9;
    cursor: pointer;
}
.file_wrapper label {
  background-color: var(--basic-color);
    width: 100%;
    height: 100%;
    margin: 0 !important;
    position: absolute;
    top: 0;
    left: 0;
    color: var(--green-color);
    cursor: pointer;
    font-weight: bold;
    display: flex !important;
    align-items: center;
    justify-content: center;
}
.shadow-sm {
  box-shadow: 0 .325rem .58rem rgba(0, 0, 0, 0.171) !important;
}

.file {
  position: relative;
  display: flex;
  align-items: center;
}

.file>input[type='file'] {
  display: none
}

.file>label {
  font-size: 1rem;
  font-weight: 300;
  cursor: pointer;
  outline: 0;
  -webkit-user-select: none;
          user-select: none;
  border-color: var(--main-color);
  border-style: solid;
  border-radius: 4px;
  border-width: 1px;
  background-color: #e0f2f1;
  color: hsl(0, 0%, 29%);
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 9px;
  padding-bottom: 7px;
}

.file--upload>label {
  color: var(--main-color) !important;
}
.delete_file {
 position: absolute;
    top: -10px;
    left: -8px;
    margin: 0 !important;
    background-color: #ca4040 !important;
    height: 20px;
    width: 20px;
    border-radius: 50% !important;
    color: var(--basic-color) !important;
}
[dir='ltr'] .delete_file {right: -8px;left: unset;}
/* handle pagination scroll */
.pagination {
  display: flex;
  flex-wrap: nowrap; /* prevent wrapping */
  overflow-x: auto;  /* enable horizontal scroll */
  -webkit-overflow-scrolling: touch; /* smooth scroll on mobile */
  scrollbar-width: thin; /* Firefox */
  padding-block: 10px !important;
}

.pagination::-webkit-scrollbar {
  height: 6px; /* horizontal scrollbar size */
}

.pagination::-webkit-scrollbar-thumb {
  background: #aaa;
  border-radius: 3px;
}

.page-item {
  flex: 0 0 auto; /* keep each item fixed size, don't shrink */
}
.custom-tooltip {
  background-color: #000 !important; 
  color: #fff !important; 
  font-weight: normal !important;  
  border-radius: 4px;
  padding: 4px 8px;
}

/* upload_photo */
.upload_photo {
      position: relative;
    background-color: #e8f6f3;
    width: 50px;
    height: 50px;
    text-align: center;
    border: 1px dashed #ccc;
    border-radius: 4px;
    cursor: pointer;
}
.upload_photo img {
  width: 40px;
  height: 40px;
  cursor: pointer;
  object-fit: cover;
  cursor: pointer;
}
.upload_photo input {
    position: absolute;
    top: 0;
    height: 100% !important;
    width: 100% !important;
    right: 0;
    margin-top: 0 !important;
    margin-bottom: 0 !important;
    opacity: 0;
    cursor: pointer;
}
.view_photo {
      width: 50px;
    height: 50px;
    object-fit: cover;
    border-radius: 3px;
    margin-inline: 4px;
}
.custom-group {position: relative;display: inline-block;}
.custom-group input {
  padding: 0;
  height: initial;
  width: initial;
  margin-bottom: 0;
  display: none;
  cursor: pointer;
}

.custom-group label {
  position: relative;
  cursor: pointer;
  display: inline-block;
}

.custom-group label:before {
  content:'';
  appearance: none;
  background-color: transparent;
  border: 2px solid var(--green-color);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05), inset 0px -15px 10px -12px rgba(0, 0, 0, 0.05);
  padding: 10px;
  display: inline-block;
  position: relative;
  vertical-align: middle;
  cursor: pointer;
}

.custom-group input:checked + label:after {
  content: '';
  display: block;
  position: absolute;
  top: 3px;
  right: 9px;
  width: 6px;
  height: 14px;
  border: solid var(--green-color);
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}
/* styled checkbox */
.styled_checkbox {
  display: flex !important;
  align-items: center;
  flex-direction: row-reverse;
  justify-content: flex-end;
  border: 1px solid #ddd;
  padding: 10px;
  border-radius: 5px;
  cursor: pointer;
  box-shadow: 0px 2px 5px 0px #eee;
}
.styled_checkbox input {
  height: auto !important;
  width: auto !important;
  accent-color: var(--green-color);
  margin: 0px 10px !important;
}
.rd3t-label__title,
.rd3t-label__attributes,.rd3t-node,.rd3t-leaf-node {
  stroke: #ffffff !important;
  stroke-width: 0 !important;
}
.flow-skeleton {
  fill: #e0e0e0;
  stroke: #d0d0d0;
  animation: shimmer 1.6s infinite linear;
}

.flow-line {
  stroke: #d0d0d0;
  stroke-width: 2;
  stroke-dasharray: 6;
  opacity: 0.6;
}

@keyframes shimmer {
  0% {
    fill: #e0e0e0;
  }
  50% {
    fill: #f5f5f5;
  }
  100% {
    fill: #e0e0e0;
  }
}

/* form style */
.form-style label {
  display: block;
  margin: 10px 0;
}
.form-style label.text-light {color: var(--sub-color) !important;font-weight: bold;}
.form-style input:not(.no-class),
.form-style select 
{
  padding: 10px;
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: var(--basic-color);
  /* height: 40px; */
  margin: 5px 0;
  font-size: 13px;
}

.form-style textarea {
  padding: 0px 10px;
  background-color: var(--basic-color);
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin: 8px 0;
  font-size: 13px;
}
.form-style input:not(.no-class),.form-style textarea {color: var(--text-lighter);}
.form-style input:not(.no-class)::placeholder,
.form-style textarea::placeholder {
  color: #333;
  font-size: 14px;
}

.form-style input:not(.no-class):focus,
.form-style textarea:focus,
.form-style select:focus {
  outline: none;
  border: 1px solid var(--green-color);
  box-shadow: 0 0 5px rgba(16, 185, 129, 0.3);
}
.no_data h5 {text-align: center !important;}
.input-no-class {
  height: auto !important;
  width: auto !important;
  box-shadow: none !important;
}
/* login & register */
.form-div {
  width:400px;
  max-width:90%;
  padding:20px;
  border-radius:7px;
  margin:20px auto;
  background-color:var(--basic-color);
  box-shadow:0px 4px 7px 4px #ddd;
}
.form-div button[type="submit"] {
  color:var(--basic-color);
  border:none;
  background-color:var(--green-color);
  border-radius:5px;
  padding-block:8px;
  margin-block:10px !important;
}
.form-div button:focus {outline:none}
.form-div label {font-weight:bold;}
.form-div input::placeholder {color:#ddd;font-size:12px;}
.form-div input:focus {border-color:var(--green-color);}
.form-div h5 {color:var(--green-color);font-weight:bold;text-align:center;margin-bottom:15px;}
  .react-select__control:hover, .react-select__control:focus,
  .react-select__control--is-focused
  {border-color: var(--main-color) !important;box-shadow: none !important;}
.css-1dimb5e-singleValue,.css-1jqq78o-placeholder{font-size: 13px;}
.css-13cymwt-control {background-color: var(--basic-color);}
/* .react-select__control {
  min-height:36px !important;
  height:36px !important;
}

.react-select__value-container {
  height:36px;
  padding: 0 8px;
}

.react-select__indicators {
  height: 36px;
}
.react-select__input-container input {height: inherit !important;} */
.custom-input-file {
  position: relative;
    background: aliceblue;
    overflow: hidden;
    border: 1px solid #ddd;
    border-radius: 5px;
    height: 41px;
}
.custom-input-file span {
    padding-inline: 10px;
    padding-block: 10px;
    font-size: .8em;
    display: block;
}
.custom-input-file input {
  height: 100%;
  margin: 0 !important;
    position: absolute;
    background: aliceblue;
    width: 100%;
    height: 100%;
    top: 0;
    opacity: 0;
}
.remove_row {
  height: 30px;
  width: 30px;
  text-align: center;
  padding: 2px 0 0 !important;
  margin-top: 36px !important;
}
.react-select__menu {font-size: small;}
.custom-span1 {
      background-color: #e8c65d;
    color: #d76420;
    font-weight: bold;
    padding: 4px 20px;
    display: inline-block;
    border-radius: 25px;
    
}
.custom-span2 {
  background-color: #a5d6cc;
    color: var(--green-color);
    font-weight: bold;
    padding: 4px 20px;
    display: inline-block;
    border-radius: 25px;
}
/* topnav */
.topnav {
  background-color: #fff;
  padding-inline-end: 0;
  padding-inline-start: 0;
  transition: all 0.3s ease-in-out;
  box-shadow: var(--shadow-light);
  border-bottom: 1px solid #e9ecef;
}

.topnav .text-light,
.topnav .toggle_sidenav .text-light,
.topnav .actions .text-light,
.topnav a.text-white {
  color: #212529 !important;
}
.topnav .dropdown-menu-end[data-bs-popper] {
    left: 0;
    right: auto;
}
.topnav .actions {
  padding: 0;
  list-style: none;
  margin: 0;
  display: flex;
  align-items: center;
}

.topnav .actions .dropdown-toggle::after {
  display: none;
}

.topnav .actions li {
  margin-inline: 3px;
  cursor: pointer;
}

.topnav .actions .dropdown-menu {
  text-align: right;
  font-size: 12px;
}

.topnav .actions li img {
  width: auto;
  max-height: 23px;
  object-fit: cover;
}
button.notification {position: relative;}
button.notification span {
  position: absolute;
    background-color: red;
    color: #fff;
    height: 17px;
    width: 17px;
    border-radius: 50%;
    font-size: 10px;
    top: -3px;
    right: 0;
    padding-top: 2px;
}
.topnav .dropdown-item {font-weight:bold;}

.topnav-user-toggle {
  display: inline-flex;
  align-items: center;
  padding: 0;
}

.topnav-user-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid rgba(255, 255, 255, 0.85);
  background: #fff;
}

.topnav-user-menu {
  min-width: 240px;
  padding-top: 0.35rem;
  padding-bottom: 0.35rem;
}

.topnav-user-menu__header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.65rem 1rem;
  pointer-events: none;
}

.topnav-user-menu__avatar {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
  border: 1px solid #dee2e6;
}

.topnav-user-menu__info {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  min-width: 0;
}

.topnav-user-menu__name {
  font-size: 0.875rem;
  font-weight: 700;
  color: #212529;
  line-height: 1.3;
  word-break: break-word;
}

.topnav-user-menu__email {
  font-size: 0.75rem;
  color: #6c757d;
  word-break: break-all;
}

/* sidenav */
.sidenav {
  background-color: var(--basic-color);
  width: var(--sidenav-width);
  box-sizing: border-box;
  max-width: 100vw;
  height: 100%;
  position: fixed;
  top: 0;
  right: 0;
  padding: 10px 20px;
  overflow-x: hidden;
  overflow-y: scroll;
  transition: all .3s ease-in-out;
  box-shadow: var(--shadow-light);
  z-index: 1040;
}

.sidenav .dropdown-menu.show {
  display: block !important;
  position: static !important;
  float: none !important;
  transform: none !important;
  inset: auto !important;
  margin-top: 5px !important;
}

.sidenav .sidenav-submenu {
  list-style: none;
  margin-block: 5px;
}

.sidenav .sidenav-submenu > .sidenav-submenu__toggle {
  display: flex !important;
  align-items: center;
  gap: 2px;
  width: 100%;
  position: relative;
  padding: 6px 10px;
  padding-inline-end: 1.75rem;
  border-radius: 6px;
  font-size: 12px;
  font-weight: bold;
  color: var(--text-gray, #777);
  background: transparent !important;
  cursor: pointer;
  white-space: pre-wrap;
}

.sidenav .sidenav-submenu > .sidenav-submenu__toggle:hover {
  background: transparent !important;
  color: var(--text-gray, #777) !important;
}

.sidenav .sidenav-submenu.active > .sidenav-submenu__toggle,
.sidenav .sidenav-submenu.show > .sidenav-submenu__toggle {
  background: transparent !important;
  color: var(--text-gray, #777) !important;
}

.sidenav .sidenav-submenu > .sidenav-submenu__toggle::after {
  inset-inline-start: auto;
  inset-inline-end: 8px;
  left: auto;
  right: 8px;
  top: 50%;
  transform: translateY(-50%) rotate(0deg);
  width: 11px;
  height: 11px;
  opacity: 0.75;
  transition: transform 0.2s ease, opacity 0.2s ease;
}

[dir="ltr"] .sidenav .sidenav-submenu > .sidenav-submenu__toggle::after {
  right: auto;
  left: 8px;
}

.sidenav .sidenav-submenu.show > .sidenav-submenu__toggle::after {
  transform: translateY(-50%) rotate(-90deg);
  opacity: 1;
}

[dir="ltr"] .sidenav .sidenav-submenu.show > .sidenav-submenu__toggle::after {
  transform: translateY(-50%) rotate(90deg);
}

.sidenav .sidenav-submenu__menu.dropdown-menu {
  display: none;
  margin: 4px 0 2px !important;
  margin-inline-start: 0.85rem !important;
  padding: 0 !important;
  width: calc(100% - 0.85rem);
  border: none;
  border-radius: 0;
  background: transparent !important;
  box-shadow: none;
}

.sidenav .sidenav-submenu.show > .sidenav-submenu__menu.dropdown-menu {
  display: block !important;
}

.sidenav .sidenav-submenu__menu > li {
  margin-block: 5px !important;
}

.sidenav .sidenav-submenu__menu > li > .dropdown-item {
  font-size: 12px;
  font-weight: bold;
  color: #777;
  white-space: pre-wrap;
  display: flex;
  background: transparent;
}

.sidenav .sidenav-submenu__menu > li > .dropdown-item:hover,
.sidenav .sidenav-submenu__menu > li.active > .dropdown-item,
.sidenav .sidenav-submenu__menu > li > .sidenav-submenu__item--active {
  background-color: var(--green-color) !important;
  color: var(--basic-color) !important;
}

body.dark-theme .sidenav .sidenav-submenu__menu.dropdown-menu,
body.dark-theme .sidenav .sidenav-submenu > .sidenav-submenu__toggle,
body.dark-theme .sidenav .sidenav-submenu.active > .sidenav-submenu__toggle,
body.dark-theme .sidenav .sidenav-submenu.show > .sidenav-submenu__toggle {
  background: transparent !important;
  color: var(--text-gray, #94a3b8) !important;
}

.sidenav .dropdown-menu {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  background-color: var(--dropdown-bg);
  text-align: right;
  font-size: small;
  padding-block: 7px;
  border: 1px solid var(--border-color);
  border-radius: 8px;
}

.sidenav .dropdown-toggle::after {
  left: 0px;
  position: absolute;
  top: 13px;
  content: "";
  display: inline-block;
  width: 13px;
  height: 13px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  margin-inline-start: 8px;
  vertical-align: middle;
  border: unset;
  transition: all .3s ease-in-out;
}

.sidenav .dropdown-menu a span {
  color: var(--sub-color);
}

.sidenav::-webkit-scrollbar {
  width: 3px;
}

.sidenav::-webkit-scrollbar-track {
  background: #ccc;
}

.sidenav::-webkit-scrollbar-thumb {
  background-color: #eeeeee40;
  border-radius: 20px;
  border: 1px solid #ddd;
}

.sidenav .main-ul {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
}

.sidenav ul {
  padding: 0;
}

.sidenav li {
  margin-block: 5px;
  font-size: 14px;
  transition: all .3s ease-in-out;
}
.sidenav .dropdown-menu li a {
  color: var(--text-lighter);
  font-size: 11px;
}

/* ——— قائمة الإعدادات (بحث + عناصر) ——— */
.sidenav .dropdown-menu.sidenav-settings-menu {
  max-height: min(70vh, 520px);
  overflow-y: auto;
}

.sidenav-settings-menu > li {
  margin-block: 0 !important;
  list-style: none;
}

.sidenav-settings-menu__head {
  position: sticky;
  top: 0;
  z-index: 3;
  padding: 10px 10px 8px;
  background: linear-gradient(
    180deg,
    var(--dropdown-bg) 0%,
    rgba(215, 100, 32, 0.06) 100%
  );
  border-bottom: 1px solid rgba(215, 100, 32, 0.18);
}

.sidenav-settings-menu__head-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
}

.sidenav-settings-menu__head-title {
  font-size: 12px;
  font-weight: 700;
  color: var(--green-color);
}

.sidenav-settings-menu__count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.65rem;
  padding: 2px 7px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 700;
  line-height: 1.2;
  color: var(--green-color);
  background: rgba(215, 100, 32, 0.14);
  border: 1px solid rgba(215, 100, 32, 0.22);
}

.sidenav-settings-menu__search-wrap {
  position: relative;
  display: flex;
  align-items: center;
}

.sidenav-settings-menu__search-icon {
  position: absolute;
  inset-inline-start: 10px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 0.8rem;
  color: #94a3b8;
  pointer-events: none;
  z-index: 1;
}

.sidenav-settings-menu__search-input {
  width: 100%;
  height: 34px;
  padding-inline-start: 2rem;
  padding-inline-end: 2rem;
  font-size: 12px;
  font-weight: 500;
  color: var(--text-lighter);
  background: var(--basic-color);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.sidenav-settings-menu__search-input::placeholder {
  color: #94a3b8;
  font-weight: 400;
}

.sidenav-settings-menu__search-input:focus {
  outline: none;
  border-color: var(--green-color);
  box-shadow: 0 0 0 3px rgba(215, 100, 32, 0.18);
}

.sidenav-settings-menu__search-clear {
  position: absolute;
  inset-inline-end: 6px;
  top: 50%;
  transform: translateY(-50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: none;
  background: transparent;
  color: #94a3b8;
  font-size: 0.95rem;
  line-height: 1;
  cursor: pointer;
  transition: color 0.15s ease;
}

.sidenav-settings-menu__search-clear:hover {
  color: var(--green-color);
}

.sidenav-settings-menu__empty {
  margin-block: 4px !important;
}

.sidenav-settings-menu__empty .dropdown-item-text {
  display: block;
  padding: 8px 12px;
  font-size: 11px;
  color: #6c757d;
  text-align: center;
}

body.dark-theme .sidenav-settings-menu__search-input {
  background: var(--input-bg);
  color: var(--text-lighter);
  border-color: var(--border-color);
}

body.dark-theme .sidenav-settings-menu__search-input::placeholder {
  color: var(--text-gray, #94a3b8);
}

.sidenav .dropdown-menu li {
  margin-block: 5px;
  transition: all .3s ease-in-out;
}

.sidenav .dropdown-menu li a:hover {
  background-color: var(--green-color);
  color: var(--basic-color);
}

.sidenav .dropdown-menu li a {
  transition: all .3s ease-in-out;
}
.sidenav li a:not(.dropdown-item) {
  display: block;
      padding: 6px;
    border-radius: 5px;
     transition: all .3s ease-in-out;
}
.sidenav li.active a:not(.dropdown-item) {
  background-color: #d76420;
    color: var(--basic-color) !important;
}
.sidenav li svg {
  width: auto;
  max-height: 30px;
  margin-left: 3px;
   transition: all .3s ease-in-out;
}
.sidenav li span {display: flex;align-items: center;font-weight: bold;transition: all .3s ease-in-out;}
.sidenav li a.dropdown-toggle {font-weight: bold;transition: all .3s ease-in-out;}
.sidenav li.active a.dropdown-toggle {
    background-color: #d76420;
    color: var(--basic-color) !important;
    /* color: #777 !important; */
}
.sidenav li.active .dropdown-toggle::after {mix-blend-mode: color-dodge;}
.sidenav li.active span {color: var(--basic-color);}
.sidenav li.active img {mix-blend-mode: color-dodge;}
.sidenav .dropdown-menu li a {
    font-size: 12px;
    font-weight: bold;
    color: #777;
    white-space: pre-wrap;
    display: flex;
}

/* Bonds toggle only: avoid white text from li.active; children use normal dropdown styles */
.sidenav .dropdown-menu .sidenav-submenu > .sidenav-submenu__toggle,
.sidenav .dropdown-menu .sidenav-submenu.active > .sidenav-submenu__toggle,
.sidenav .dropdown-menu .sidenav-submenu.show > .sidenav-submenu__toggle,
.sidenav li.active .dropdown-menu .sidenav-submenu > .sidenav-submenu__toggle,
.sidenav li.active .dropdown-menu .sidenav-submenu.active > .sidenav-submenu__toggle {
  background: transparent !important;
  color: #777 !important;
}

.sidenav .dropdown-menu .sidenav-submenu > .sidenav-submenu__toggle .sidenav-submenu__label,
.sidenav .dropdown-menu .sidenav-submenu.active > .sidenav-submenu__toggle .sidenav-submenu__label,
.sidenav li.active .dropdown-menu .sidenav-submenu > .sidenav-submenu__toggle span.sidenav-submenu__label {
  color: #777 !important;
}

.sidenav .dropdown-menu .sidenav-submenu__menu > li > a.dropdown-item {
  font-size: 12px;
  font-weight: bold;
  color: #777;
  background: transparent;
}

.sidenav .dropdown-menu .sidenav-submenu__menu > li > a.dropdown-item:hover,
.sidenav .dropdown-menu .sidenav-submenu__menu > li > a.sidenav-submenu__item--active,
.sidenav .dropdown-menu .sidenav-submenu__menu > li.active > a.dropdown-item {
  background-color: var(--green-color) !important;
  color: var(--basic-color) !important;
}

body.dark-theme .sidenav .dropdown-menu .sidenav-submenu > .sidenav-submenu__toggle,
body.dark-theme .sidenav .dropdown-menu .sidenav-submenu.active > .sidenav-submenu__toggle,
body.dark-theme .sidenav li.active .dropdown-menu .sidenav-submenu > .sidenav-submenu__toggle span.sidenav-submenu__label {
  color: var(--text-gray, #94a3b8) !important;
  background: transparent !important;
}
/* Layout main — padding بعرض السايدبار والسايدبار ثابت يمين */
.app-layout__main {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
  box-sizing: border-box;
  transition: padding 0.3s ease-in-out;
}

.app-layout__main.full-width,
body.sidenav-docked-closed .app-layout__main {
  padding: 0 !important;
}

/* content wrapper — يبدأ مباشرة بعد عرض السايدبار */
.content_wrapper {
  padding-inline: 12px;
  margin-block: 20px;
  transition: margin 0.3s ease-in-out, width 0.3s ease-in-out, max-width 0.3s ease-in-out;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  position: relative;
  z-index: 1;
  margin-inline: 0;
}

/* السايدبار مغلق أو overlay (موبايل) — المحتوى بعرض الشاشة كامل */
.content_wrapper.full-width,
body.sidenav-docked-closed .content_wrapper {
  margin-inline: 0 !important;
  width: 100% !important;
  max-width: 100% !important;
}

/* @media (max-width: 500px) {
  .topnav .dropdown-menu-end[data-bs-popper] {
    right: 0;
    left: auto;
}
} */
 .modal-body {font-weight: bold;}
 .accordion-button {margin: 0 !important;}
 .accordion-button::after
 {
  background-size: 17px !important;
  margin-right: auto;
  margin-left: unset !important;
  transform: unset !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) !important;
}
.accordion-button:not(.collapsed)::after
 {
  background-size: 17px !important;
  margin-right: auto;
  margin-left: unset !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) !important;
  transform: unset !important;
}

.accordion-button:not(.collapsed)
{
  background-color: #eee !important;
}
.accordion-button h5 {
  font-size: 17px;
    font-weight: bold;
    color: #333;
}
.accordion-button:focus {box-shadow: none !important;border: none;}
@media (min-width: 1191px) {
  .sidenav.openNav {
    right: 0;
  }

  .sidenav.closedNav {
    right: calc(-1 * var(--sidenav-width));
  }

  html[dir="rtl"] .app-layout__main.with-sidenav,
  html[dir="rtl"] body.sidenav-docked-open .app-layout__main,
  [dir="rtl"] .app-layout__main.with-sidenav,
  [dir="rtl"] body.sidenav-docked-open .app-layout__main {
    padding-right: var(--sidenav-width);
    padding-left: 0;
  }

  html[dir="ltr"] .app-layout__main.with-sidenav,
  html[dir="ltr"] body.sidenav-docked-open .app-layout__main,
  [dir="ltr"] .app-layout__main.with-sidenav,
  [dir="ltr"] body.sidenav-docked-open .app-layout__main {
    padding-left: var(--sidenav-width);
    padding-right: 0;
  }

  .app-layout__main.with-sidenav > .content_wrapper > .container {
    max-width: 100%;
    width: 100%;
    padding-inline: 0;
  }

  .closeNav {
    display: none;
  }
}

@media (max-width: 1190px) {
  .sidenav {
    right: calc(-1 * var(--sidenav-width)); /* default closed */
  }

  .sidenav.openNav {
    right: 0;
  }

  .sidenav.closedNav {
    right: calc(-1 * var(--sidenav-width));
  }

  .content_wrapper {
    margin-inline-end: 0 !important;
    margin-inline-start: 0 !important;
    width: 100% !important;
  }

  .app-layout__main,
  .app-layout__main.with-sidenav {
    padding: 0 !important;
  }

  .topnav {
    padding-right: 0 !important;
  }

  .closeNav {
    display: block;
    color: var(--sub-color);
    position: absolute;
    left: 10px;
    top: 10px;
    font-size: 24px;
    cursor: pointer;
  }
  
}
@media(max-width:410px) 
{
  .navbar>.container {flex-wrap: nowrap !important;}
}
/* end media */
.sidenav {
  background-color: var(--gray-color);
  width: var(--sidenav-width);
  box-sizing: border-box;
  max-width: 100vw;
  height: 100%;
  position: fixed;
  top: 0;
  right: 0;
  padding: 10px 20px;
  overflow-x: hidden;
  overflow-y: auto;
  transition: all 0.3s ease-in-out;
  z-index: 1040;
}

.content_wrapper {
  transition: all 0.3s ease-in-out;
  padding-inline: 12px;
  margin-block: 20px;
}

.topnav {
  background-color: #fff;
  transition: all 0.3s ease-in-out;
  padding-top: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e9ecef;
}
.fixed-top {padding-top: 10px !important;padding-bottom: 10px !important;z-index: 2 !important;}
.topnav--modern.fixed-top {z-index: 1030 !important;}
/* ######### [dir ltr] ########## */

@font-face {
  font-family: 'Nunito';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('woff2'),
       url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('truetype');
  font-display: swap;
  font-weight: 400;
  font-style: normal;
}
[dir="ltr"] body {
  text-align: left;
  font-family: 'Nunito', sans-serif !important;
  direction: ltr !important;
}
[dir="ltr"] .sidenav li {
        text-align: left;
}
[dir="ltr"] .sidenav li svg {margin-right: 3px;margin-left: 0 !important;}
[dir="ltr"] .sidenav .dropdown-toggle::after {
  right: 0px;
  left: unset;
  margin-inline-start: 0px;
  margin-inline-end: 8px;
}
[dir="ltr"] .sidenav .dropdown-menu li a i::before {
  transform: rotate(180deg);
  margin-right: 2px !important;
  margin-left: 0 !important;
}
[dir="ltr"] .sidenav li img {margin-right: 3px;margin-left: 0px;}
[dir="ltr"] .topnav .dropdown-menu-end[data-bs-popper] {
    right: 0;
    left: auto;
}
[dir="ltr"] .topnav .dropdown-menu,
[dir="ltr"] .providers_on_map h5
 {text-align: left;}
 [dir="ltr"] .table_form b
 {text-align: left;}
 [dir="ltr"] .circle_chart b, [dir="ltr"] .circle_chart h5 {
    margin-left: 5px;
    margin-right: 0px;
    text-align: left;
}
[dir="ltr"] .topnav .actions li a ,
[dir="ltr"] .topnav .actions li ul button {font-weight: bold;font-size: 13px;}
[dir="ltr"] .stat_card,
[dir="ltr"] .table_form label,
[dir="ltr"] .table_form select
 {text-align: left;}
[dir="ltr"] .stat_card img {
  transform: scalex(-1);
}
[dir="ltr"] .accordion-button::after {margin-left: auto !important;margin-right: unset !important;}
[dir="ltr"] .sidenav .dropdown-menu li a {font-size: 12px;}
[dir="ltr"] select {background-position: right 14px center !important;}
[dir="ltr"] .chart-text {font-family: 'Nunito',sans-serif !important;}
.ar-lang {font-weight: bold !important;}
[dir="ltr"] .ar-lang {font-family: 'Janna',sans-serif !important;}
[dir="ltr"] .chart-text {border-left: 1px solid #eeeeee26;border-right:none}
[dir="ltr"] .pagination .page-item:first-child .page-link {
    border-radius: 50%;
    border-top-right-radius: var(--bs-pagination-border-radius);
    border-bottom-right-radius: var(--bs-pagination-border-radius);
}
[dir="ltr"] .pagination .page-item:last-child .page-link {
    border-radius: 50%;
    border-top-left-radius: var(--bs-pagination-border-radius);
    border-bottom-left-radius: var(--bs-pagination-border-radius);
}
[dir="ltr"] .pagination .page-item .page-link i {transform: rotate(180deg);}
[dir="ltr"] .view,[dir="ltr"] .toggle {text-align: left;}
[dir="ltr"] .table_form label{font-weight: bold;font-size: 14px;}
.toggle {float: right;}
[dir="ltr"] .toggle {float: left;}
[dir="ltr"] .btn {font-weight: bold;}
[dir="ltr"] .modal-body ,
[dir="ltr"] .tab-content ,
[dir="ltr"] .form-style ,
[dir="ltr"] h5 ,
[dir="ltr"] h3
{text-align: left;}
[dir="ltr"] .custom-radio {margin-right: 0 !important;margin-left: 10px !important;}
[dir="ltr"] .text-custom {font-weight: bold;}
[dir="ltr"] .content_wrapper .table tbody tr  td {font-weight: bold;}
[dir="ltr"] .sidenav .dropdown-toggle::after {top: 10px;}
.total_amounts {text-align: left;}
[dir="ltr"] .total_amounts {text-align: right;}
[dir="ltr"] .custom-group input:checked + label:after {
  right: unset !important;
  left: 9px;
}
@media (max-width: 500px) {
    [dir="rtl "] .topnav .dropdown-menu-end[data-bs-popper] {
        right: auto !important;
        left: 0 !important;
    }
}
/* ####### media [dir="ltr"] ###### */
@media (min-width: 1191px) {
  [dir="ltr"] .sidenav.openNav {
        left: 0;
        right: unset;
  }
  [dir="ltr"] .sidenav.closedNav {
        left: calc(-1 * var(--sidenav-width));
        right: unset;
    }
}
@media (max-width: 1190px) {
    [dir="ltr"] .sidenav.openNav {
        left: 0;
        right: unset;
    }
    [dir="ltr"] .sidenav.closedNav {
        left: calc(-1 * var(--sidenav-width));
        right: unset;
    }
    [dir="ltr"] .closeNav {
        right: 10px;
        left: unset;
    }
}

/* NotFound Page Styles */
.not-found-container {
  min-height: calc(100vh - 0px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  position: relative;
  overflow: hidden;
}

.not-found-wrapper {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 700px;
}

.not-found-content {
  background: var(--basic-color);
  border-radius: 24px;
  padding: 3rem 2rem;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.1);
  text-align: center;
  position: relative;
  overflow: hidden;
  animation: fadeInUp 0.6s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.not-found-illustration {
  position: relative;
  margin-bottom: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
}

.error-code {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  font-size: 8rem;
  font-weight: 900;
  color: var(--green-color);
  line-height: 1;
  position: relative;
  z-index: 2;
  animation: bounce 2s infinite;
}

.error-digit {
  display: inline-block;
  position: relative;
  text-shadow: 0 4px 8px rgba(0, 106, 83, 0.2);
  transition: transform 0.3s ease;
}

.error-digit.middle {
  animation: pulse 1.5s infinite;
}

@keyframes bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
}

.error-icon-wrapper {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  opacity: 0.1;
}

.error-icon {
  font-size: 15rem;
  color: var(--green-color);
  animation: rotate 20s linear infinite;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.not-found-text {
  margin-bottom: 2.5rem;
}

.not-found-title {
  font-size: 2rem;
  font-weight: 700;
  color: var(--main-color);
  margin-bottom: 1rem;
  line-height: 1.2;
}

.not-found-message {
  font-size: 1rem;
  color: var(--text-lighter);
  line-height: 1.6;
  max-width: 500px;
  margin: 0 auto;
}

.not-found-actions {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
}

.btn-not-found {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.875rem 2rem;
  border-radius: 12px;
  font-weight: 600;
  font-size: 1rem;
  text-decoration: none;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.btn-not-found::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  transition: left 0.5s ease;
}

.btn-not-found:hover::before {
  left: 100%;
}

.btn-primary-not-found {
  background: linear-gradient(135deg, var(--green-color) 0%, #005a47 100%);
  color: var(--basic-color);
  box-shadow: 0 4px 15px rgba(0, 106, 83, 0.3);
}

.btn-primary-not-found:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 106, 83, 0.4);
  color: var(--basic-color);
}

.btn-secondary-not-found {
  background: var(--basic-color);
  color: var(--green-color);
  border: 2px solid var(--green-color);
}

.btn-secondary-not-found:hover {
  background: var(--green-color);
  color: var(--basic-color);
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0, 106, 83, 0.2);
}

.btn-icon {
  font-size: 1.25rem;
  transition: transform 0.3s ease;
}

.btn-not-found:hover .btn-icon {
  transform: translateX(4px);
}

.btn-not-found:hover .btn-icon.rotate {
  transform: translateX(-4px);
}

.not-found-decoration {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 0;
}

.decoration-circle {
  position: absolute;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--green-color), #005a47);
  opacity: 0.1;
  animation: float 6s ease-in-out infinite;
}

.circle-1 {
  width: 200px;
  height: 200px;
  top: -100px;
  right: -100px;
  animation-delay: 0s;
}

.circle-2 {
  width: 150px;
  height: 150px;
  bottom: -75px;
  left: -75px;
  animation-delay: 2s;
}

.circle-3 {
  width: 100px;
  height: 100px;
  top: 50%;
  right: 10%;
  animation-delay: 4s;
}

@keyframes float {
  0%, 100% {
    transform: translateY(0) rotate(0deg);
  }
  50% {
    transform: translateY(-20px) rotate(180deg);
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .not-found-container {
    padding: 1rem;
    min-height: calc(100vh - 80px);
  }

  .not-found-content {
    padding: 2rem 1.5rem;
  }

  .error-code {
    font-size: 5rem;
  }

  .error-icon {
    font-size: 10rem;
  }

  .not-found-title {
    font-size: 1.5rem;
  }

  .not-found-message {
    font-size: 0.9rem;
  }

  .btn-not-found {
    padding: 0.75rem 1.5rem;
    font-size: 0.9rem;
  }

  .not-found-actions {
    flex-direction: column;
    align-items: stretch;
  }

  .btn-not-found {
    width: 100%;
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .error-code {
    font-size: 4rem;
  }

  .error-icon {
    font-size: 8rem;
  }

  .not-found-title {
    font-size: 1.25rem;
  }
}

[dir='ltr'] .dropdown-toggle::after {
    display: inline-block;
    margin-left: .255em;
    margin-right: 0em;
}
[dir='rtl'] .dropdown-toggle::after {
    display: inline-block;
    margin-right: .255em;
    margin-left: 0em;
}
/* RTL Support */
[dir="rtl"] .btn-not-found:hover .btn-icon {
  transform: translateX(-4px);
}

[dir="rtl"] .btn-not-found:hover .btn-icon.rotate {
  transform: translateX(4px);
}

/* Global Dark Mode Fixes for Bootstrap Components */
body.dark-theme .table {
  --bs-table-bg: transparent;
  --bs-table-color: var(--text-lighter);
  color: var(--text-lighter) !important;
  border-color: var(--border-color);
}
body.dark-theme .table > :not(caption) > * > * {
  background-color: transparent !important;
  color: var(--text-lighter) !important;
  border-bottom-color: var(--border-color) !important;
}
body.dark-theme .table-striped > tbody > tr:nth-of-type(odd) > * {
  background-color: rgba(255, 255, 255, 0.05) !important;
  color: var(--text-lighter) !important;
}
body.dark-theme .table-hover > tbody > tr:hover > * {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: var(--text-lighter) !important;
}

.input-div {
  background-color: var(--input-bg) !important;
  color: var(--sub-color) !important;
  border: 1px solid var(--border-color) !important;
  border-radius: 4px;
  padding: 10px;
  width: 100%;
}
body.dark-theme .input-div {
  color: var(--text-lighter) !important;
}

body.dark-theme .bg-white,
body.dark-theme .bg-light {
  background-color: var(--basic-color) !important;
  color: var(--text-lighter) !important;
  border-color: var(--border-color) !important;
}

/* React Select Dark Mode Overrides */
body.dark-theme .css-13cymwt-control,
body.dark-theme .react-select__control,
body.dark-theme [class*="-control"] {
  background-color: var(--input-bg) !important;
  border-color: var(--border-color) !important;
}

body.dark-theme .css-1dimb5e-singleValue,
body.dark-theme .react-select__single-value,
body.dark-theme [class*="-singleValue"] {
  color: var(--text-lighter) !important;
}

body.dark-theme .css-1jqq78o-placeholder,
body.dark-theme .react-select__placeholder,
body.dark-theme [class*="-placeholder"] {
  color: #94A3B8 !important;
}

body.dark-theme .react-select__menu,
body.dark-theme [class*="-menu"] {
  background-color: var(--dropdown-bg) !important;
  border: 1px solid var(--border-color) !important;
}

body.dark-theme .react-select__option,
body.dark-theme [class*="-option"] {
  background-color: transparent;
  color: var(--text-lighter) !important;
}

body.dark-theme .react-select__option--is-focused,
body.dark-theme .react-select__option:hover,
body.dark-theme [class*="-option"][id*="focused"] {
  background-color: rgba(255, 255, 255, 0.1) !important;
}

body.dark-theme .react-select__option--is-selected {
  background-color: var(--green-color) !important;
  color: #fff !important;
}

body.dark-theme .react-select__indicator,
body.dark-theme [class*="-indicatorContainer"] {
  color: var(--text-lighter) !important;
}

/* Custom SearchableDropdown Dark Mode Overrides */
body.dark-theme [class*="SearchableDropdown_dropdownTrigger"] {
  background-color: var(--input-bg) !important;
  border-color: var(--border-color) !important;
}

body.dark-theme [class*="SearchableDropdown_selected"] {
  color: var(--text-lighter) !important;
}

body.dark-theme [class*="SearchableDropdown_placeholder"] {
  color: #94A3B8 !important;
}

body.dark-theme [class*="SearchableDropdown_dropdownMenu"] {
  background-color: var(--dropdown-bg) !important;
  border-color: var(--border-color) !important;
}

body.dark-theme [class*="SearchableDropdown_searchInput"] {
  background-color: var(--input-bg) !important;
  color: var(--text-lighter) !important;
  border-color: var(--border-color) !important;
}

body.dark-theme [class*="SearchableDropdown_dropdownOption"] {
  border-bottom-color: var(--border-color) !important;
  color: var(--text-lighter) !important;
}

body.dark-theme [class*="SearchableDropdown_dropdownOption"]:hover {
  background-color: rgba(255, 255, 255, 0.1) !important;
}

body.dark-theme [class*="SearchableDropdown_dropdownOptionSelected"],
body.dark-theme [class*="SearchableDropdown_dropdownOptionSelected"]:hover {
  background-color: var(--green-color) !important;
  color: #fff !important;
}

body.dark-theme [class*="SearchableDropdown_dropdownSearch"] {
  border-bottom-color: var(--border-color) !important;
}

body.dark-theme [class*="SearchableDropdown_dropdownLoading"],
body.dark-theme [class*="SearchableDropdown_dropdownNoResults"],
body.dark-theme [class*="SearchableDropdown_dropdownPaginationInfo"] {
  color: #94A3B8 !important;
  background-color: transparent !important;
  border-top-color: var(--border-color) !important;
}

/* Deep Project Custom Component Dark Overrides */
body.dark-theme .profile-container,
body.dark-theme .profile-form,
body.dark-theme .profile-card,
body.dark-theme .providers_on_map .input-div,
body.dark-theme .providers_on_map select,
body.dark-theme .providers_on_map input {
  background-color: var(--basic-color) !important;
  color: var(--text-lighter) !important;
  border-color: var(--border-color) !important;
}

body.dark-theme .profile-card .profile-info p {
  color: var(--text-lighter) !important;
}

/* =========================================
   Mobile Responsiveness Overrides
   ========================================= */

/* Tablets (max-width: 991px) */
@media (max-width: 991px) {
  .content_wrapper {
    padding-inline: 15px !important;
    margin-block: 15px !important;
  }
  .form-style, .table_form {
    padding: 15px !important;
  }
}

/* Mobile Devices (max-width: 768px) */
@media (max-width: 768px) {
  .content_wrapper {
    padding-inline: 10px !important;
    margin-block: 10px !important;
  }

  .form-style, .table_form {
    padding: 10px !important;
  }

  /* Typography Scaling */
  h2 { font-size: 1.5rem !important; }
  h3 { font-size: 1.3rem !important; }
  h4 { font-size: 1.1rem !important; }
  .text-md { font-size: 1rem !important; }

  /* Navbar Adjustments */
  .topnav .container {
    padding-inline: 10px;
  }
  
  .topnav .actions {
    gap: 5px;
  }
  
  .topnav .actions .dropdown-toggle {
    padding-inline: 5px;
  }

  .topnav .actions li.me-3 {
    margin-right: 5px !important;
  }

  /* Flexible Form Alignment */
  .form-style .d-flex {
    flex-wrap: wrap;
    gap: 10px;
  }
}

/* Small Mobile Devices (max-width: 576px) */
@media (max-width: 576px) {
  .toggle_sidenav span {
    padding: 8px !important;
  }

  .toggle_sidenav {
    gap: 0.25rem !important;
  }

  /* Navbar Icons Resizing */
  .topnav .actions li button svg {
    font-size: 20px !important;
  }

  /* Adjust Modal padding */
  .modal-body {
    padding: 10px;
  }

  /* Cards */
  .stat_card {
    padding: 15px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,WAAW;EACX,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;EAC1B,0BAA0B;EAC1B,yBAAyB;EACzB,oBAAoB;EACpB,8DAA8D;EAC9D,8DAA8D;EAC9D,qBAAqB;EACrB,uBAAuB;EACvB,gDAAgD;EAChD,sBAAsB;EACtB,kBAAkB;EAClB,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,oBAAoB;EACpB,sBAAsB;EACtB,0BAA0B;EAC1B,0BAA0B;EAC1B,yBAAyB;EACzB,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,+CAA+C;EAC/C,sBAAsB;EACtB,kBAAkB;EAClB,4CAA4C;;EAE5C,wBAAwB;EACxB,oCAAoC;EACpC,uCAAuC;EACvC,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uDAAuD;EACvD,kBAAkB;AACpB;;;AAGA;EACE,oBAAoB;EACpB;iEAC8D;EAC9D,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,2CAA2C;EAC3C,kBAAkB;EAClB,4BAA4B;EAC5B,8CAA8C;EAC9C,0BAA0B;AAC5B;;AAEA,WAAW;AACX;EACE,2CAA2C;EAC3C,4BAA4B;AAC9B;AACA,cAAc,0CAA0C,CAAC;AACzD;;EAEE,eAAe;AACjB;;AAEA,mDAAmD;AACnD;;;EAGE,uDAAuD;EACvD,mDAAmD;EACnD,sBAAsB;AACxB;;AAEA;;;;;;EAME,oCAAoC;EACpC,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;;;EAGE,uDAAuD;EACvD,mDAAmD;EACnD,sBAAsB;EACtB,aAAa;AACf;;AAEA;;EAEE,aAAa;AACf;;AAEA;;;;;EAKE,YAAY;AACd;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;AACrC;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,wCAAwC;AAC1C;AACA,kBAAkB,wCAAwC,CAAC;AAC3D,iBAAiB,uCAAuC,CAAC;AACzD;EACE,6BAA6B;AAC/B;AACA,iBAAiB,sCAAsC,CAAC;AACxD;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;AACA,cAAc,eAAe,CAAC,iBAAiB,CAAC;AAChD;EACE,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;AACA,SAAS,oCAAoC,CAAC;AAC9C;EACE,4CAA4C;EAC5C,kCAAkC;EAClC,4CAA4C;AAC9C;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,oEAAqD;EACrD,4BAA4B;EAC5B,0BAA0B;EAC1B,kBAAkB;EAClB,gDAAgD;EAChD,iCAAiC;AACnC;AACA,aAAa,gBAAgB,CAAC,kBAAkB,CAAC;AACjD;EACE,YAAY;EACZ,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,0CAA0C;EAC1C,2CAA2C;EAC3C,yBAAyB;EACzB,oCAAoC;AACtC;AACA;EACE,kBAAkB;IAChB,oCAAoC;IACpC,oCAAoC;IACpC,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,6CAA6C;AACjD;AACA;EACE,2BAA2B;EAC3B,UAAU;IACR,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,UAAU;IACV,eAAe;AACnB;AACA;EACE,oCAAoC;IAClC,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,yBAAyB;IACzB,eAAe;IACf,iBAAiB;IACjB,wBAAwB;IACxB,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;EACE,4DAA4D;AAC9D;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,yBAAiB;UAAjB,iBAAiB;EACjB,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;AACrC;AACA;CACC,kBAAkB;IACf,UAAU;IACV,UAAU;IACV,oBAAoB;IACpB,oCAAoC;IACpC,YAAY;IACZ,WAAW;IACX,6BAA6B;IAC7B,oCAAoC;AACxC;AACA,0BAA0B,WAAW,CAAC,WAAW,CAAC;AAClD,6BAA6B;AAC7B;EACE,aAAa;EACb,iBAAiB,EAAE,qBAAqB;EACxC,gBAAgB,GAAG,6BAA6B;EAChD,iCAAiC,EAAE,4BAA4B;EAC/D,qBAAqB,EAAE,YAAY;EACnC,8BAA8B;AAChC;;AAEA;EACE,WAAW,EAAE,8BAA8B;AAC7C;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc,EAAE,4CAA4C;AAC9D;AACA;EACE,iCAAiC;EACjC,sBAAsB;EACtB,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;MACM,kBAAkB;IACpB,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,uBAAuB;IACvB,sBAAsB;IACtB,QAAQ;IACR,wBAAwB;IACxB,2BAA2B;IAC3B,UAAU;IACV,eAAe;AACnB;AACA;MACM,WAAW;IACb,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB;AACA,eAAe,kBAAkB,CAAC,qBAAqB,CAAC;AACxD;EACE,UAAU;EACV,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,UAAU;EAEV,gBAAgB;EAChB,6BAA6B;EAC7B,oCAAoC;EACpC,yFAAyF;EACzF,aAAa;EACb,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;EACV,YAAY;EACZ,gCAAgC;EAChC,yBAAyB;EACzB,wBAAwB;AAC1B;AACA,oBAAoB;AACpB;EACE,wBAAwB;EACxB,mBAAmB;EACnB,2BAA2B;EAC3B,yBAAyB;EACzB,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,gCAAgC;AAClC;AACA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,gCAAgC;EAChC,2BAA2B;AAC7B;AACA;;EAEE,0BAA0B;EAC1B,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;AACF;;AAEA,eAAe;AACf;EACE,cAAc;EACd,cAAc;AAChB;AACA,8BAA8B,kCAAkC,CAAC,iBAAiB,CAAC;AACnF;;;EAGE,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,oCAAoC;EACpC,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;AACA,uDAAuD,0BAA0B,CAAC;AAClF;;EAEE,WAAW;EACX,eAAe;AACjB;;AAEA;;;EAGE,aAAa;EACb,oCAAoC;EACpC,2CAA2C;AAC7C;AACA,aAAa,6BAA6B,CAAC;AAC3C;EACE,uBAAuB;EACvB,sBAAsB;EACtB,2BAA2B;AAC7B;AACA,qBAAqB;AACrB;EACE,WAAW;EACX,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,mCAAmC;EACnC,+BAA+B;AACjC;AACA;EACE,wBAAwB;EACxB,WAAW;EACX,mCAAmC;EACnC,iBAAiB;EACjB,iBAAiB;EACjB,4BAA4B;AAC9B;AACA,wBAAwB,YAAY;AACpC,iBAAiB,gBAAgB,CAAC;AAClC,8BAA8B,UAAU,CAAC,cAAc,CAAC;AACxD,uBAAuB,+BAA+B,CAAC;AACvD,cAAc,wBAAwB,CAAC,gBAAgB,CAAC,iBAAiB,CAAC,kBAAkB,CAAC;EAC3F;;GAEC,0CAA0C,CAAC,2BAA2B,CAAC;AAC1E,kDAAkD,eAAe,CAAC;AAClE,sBAAsB,oCAAoC,CAAC;AAC3D;;;;;;;;;;;;;oEAaoE;AACpE;EACE,kBAAkB;IAChB,qBAAqB;IACrB,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;IACf,cAAc;AAClB;AACA;EACE,YAAY;EACZ,oBAAoB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,MAAM;IACN,UAAU;AACd;AACA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,2BAA2B;EAC3B,2BAA2B;AAC7B;AACA,qBAAqB,gBAAgB,CAAC;AACtC;MACM,yBAAyB;IAC3B,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB,qBAAqB;IACrB,mBAAmB;;AAEvB;AACA;EACE,yBAAyB;IACvB,yBAAyB;IACzB,iBAAiB;IACjB,iBAAiB;IACjB,qBAAqB;IACrB,mBAAmB;AACvB;AACA,WAAW;AACX;EACE,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,gCAAgC;EAChC,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;;;;EAIE,yBAAyB;AAC3B;AACA;IACI,OAAO;IACP,WAAW;AACf;AACA;EACE,UAAU;EACV,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;AACA,qBAAqB,kBAAkB,CAAC;AACxC;EACE,kBAAkB;IAChB,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,SAAS;IACT,QAAQ;IACR,gBAAgB;AACpB;AACA,wBAAwB,gBAAgB,CAAC;;AAEzC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,qBAAqB;AACvB;;AAEA,YAAY;AACZ;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,MAAM;EACN,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;EAC/B,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,sBAAsB;EACtB,0BAA0B;EAC1B,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,6BAA6B;EAC7B,kCAAkC;EAClC,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;AAC1C;;AAEA;;EAEE,kCAAkC;EAClC,wCAAwC;AAC1C;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,UAAU;EACV,UAAU;EACV,QAAQ;EACR,wCAAwC;EACxC,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kDAAkD;AACpD;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;EACE,0CAA0C;EAC1C,UAAU;AACZ;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,uCAAuC;EACvC,qBAAqB;EACrB,2BAA2B;EAC3B,YAAY;EACZ,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,qBAAqB;EACrB,aAAa;EACb,uBAAuB;AACzB;;AAEA;;;EAGE,+CAA+C;EAC/C,oCAAoC;AACtC;;AAEA;;;;EAIE,kCAAkC;EAClC,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,oCAAoC;EACpC,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,yDAA4C;EAC5C,wBAAwB;EACxB,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EACxB,sBAAsB;EACtB,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,+BAA+B;AACjC;AACA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA,0CAA0C;AAC1C;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,sBAAsB;EACtB;;;;GAIC;EACD,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,oCAAoC;EACpC,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,QAAQ;EACR,2BAA2B;EAC3B,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,8BAA8B;EAC9B,qCAAqC;EACrC,kBAAkB;EAClB,wDAAwD;AAC1D;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;AACA;EACE,cAAc;MACV,YAAY;IACd,kBAAkB;KACjB,+BAA+B;AACpC;AACA;EACE,yBAAyB;IACvB,oCAAoC;AACxC;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;GACf,+BAA+B;AAClC;AACA,kBAAkB,aAAa,CAAC,mBAAmB,CAAC,iBAAiB,CAAC,+BAA+B,CAAC;AACtG,+BAA+B,iBAAiB,CAAC,+BAA+B,CAAC;AACjF;IACI,yBAAyB;IACzB,oCAAoC;IACpC,4BAA4B;AAChC;AACA,4CAA4C,2BAA2B,CAAC;AACxE,yBAAyB,yBAAyB,CAAC;AACnD,wBAAwB,2BAA2B,CAAC;AACpD;IACI,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,qBAAqB;IACrB,aAAa;AACjB;;AAEA,4FAA4F;AAC5F;;;;;EAKE,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,uBAAuB;AACzB;;AAEA;;;EAGE,+CAA+C;EAC/C,oCAAoC;AACtC;;AAEA;;;EAGE,2CAA2C;EAC3C,kCAAkC;AACpC;AACA,8DAA8D;AAC9D;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,WAAW;EACX,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA,oDAAoD;AACpD;EACE,oBAAoB;EACpB,kBAAkB;EAClB,uFAAuF;EACvF,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;AAClB;;AAEA,kEAAkE;AAClE;;EAEE,2BAA2B;EAC3B,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;;;;;GAKG;CACF,aAAa,iBAAiB,CAAC;CAC/B,mBAAmB,oBAAoB,CAAC;CACxC;;EAEC,gCAAgC;EAChC,kBAAkB;EAClB,6BAA6B;EAC7B,2BAA2B;EAC3B,oEAAsD;AACxD;AACA;;EAEE,gCAAgC;EAChC,kBAAkB;EAClB,6BAA6B;EAC7B,oEAAuD;EACvD,2BAA2B;AAC7B;;AAEA;;EAEE,iCAAiC;AACnC;AACA;EACE,eAAe;IACb,iBAAiB;IACjB,WAAW;AACf;AACA,yBAAyB,2BAA2B,CAAC,YAAY,CAAC;AAClE;EACE;IACE,QAAQ;EACV;;EAEA;IACE,sCAAsC;EACxC;;EAEA;;;;IAIE,mCAAmC;IACnC,eAAe;EACjB;;EAEA;;;;IAIE,kCAAkC;IAClC,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,sCAAsC,EAAE,mBAAmB;EAC7D;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,+BAA+B;IAC/B,iCAAiC;IACjC,sBAAsB;EACxB;;EAEA;;IAEE,qBAAqB;EACvB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,cAAc;IACd,uBAAuB;IACvB,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,eAAe;IACf,eAAe;EACjB;;AAEF;AACA;;EAEE,oBAAoB,4BAA4B,CAAC;AACnD;AACA,cAAc;AACd;EACE,mCAAmC;EACnC,2BAA2B;EAC3B,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,MAAM;EACN,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,gCAAgC;EAChC,iBAAiB;EACjB,oBAAoB;EACpB,gCAAgC;AAClC;AACA,YAAY,4BAA4B,CAAC,+BAA+B,CAAC,qBAAqB,CAAC;AAC/F,2BAA2B,wBAAwB,CAAC;AACpD,mCAAmC;;AAEnC;EACE,qBAAqB;EACrB;iEACmD;EACnD,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,4CAA4C;EAC5C,yBAAyB;AAC3B;AACA;QACQ,gBAAgB;AACxB;AACA,6BAA6B,iBAAiB,CAAC,yBAAyB,CAAC;AACzE;EACE,UAAU;EACV,WAAW;EACX,wBAAwB;EACxB,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,yBAAyB;AAC3B;AACA,6BAA6B,iBAAiB,CAAC,gBAAgB,CAAC;AAChE;IACI,QAAQ;IACR,UAAU;AACd;AACA;;EAEE,gBAAgB,CAAC;CAClB;EACC,gBAAgB,CAAC;CAClB;IACG,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;AACA;2CAC2C,iBAAiB,CAAC,eAAe,CAAC;AAC7E;;;EAGE,gBAAgB,CAAC;AACnB;EACE,qBAAqB;AACvB;AACA,sCAAsC,4BAA4B,CAAC,8BAA8B,CAAC;AAClG,0CAA0C,eAAe,CAAC;AAC1D,oBAAoB,iDAAiD,CAAC;AACtE,yBAAyB,2CAA2C,CAAC;AACrE,UAAU,4BAA4B,CAAC;AACvC,sBAAsB,0CAA0C,CAAC;AACjE,yBAAyB,gCAAgC,CAAC,iBAAiB;AAC3E;IACI,kBAAkB;IAClB,2DAA2D;IAC3D,8DAA8D;AAClE;AACA;IACI,kBAAkB;IAClB,0DAA0D;IAC1D,6DAA6D;AACjE;AACA,iDAAiD,yBAAyB,CAAC;AAC3E,uCAAuC,gBAAgB,CAAC;AACxD,8BAA8B,iBAAiB,CAAC,eAAe,CAAC;AAChE,SAAS,YAAY,CAAC;AACtB,qBAAqB,WAAW,CAAC;AACjC,kBAAkB,iBAAiB,CAAC;AACpC;;;;;CAKC,gBAAgB,CAAC;AAClB,2BAA2B,0BAA0B,CAAC,4BAA4B,CAAC;AACnF,0BAA0B,iBAAiB,CAAC;AAC5C,kDAAkD,iBAAiB,CAAC;AACpE,8CAA8C,SAAS,CAAC;AACxD,gBAAgB,gBAAgB,CAAC;AACjC,4BAA4B,iBAAiB,CAAC;AAC9C;EACE,uBAAuB;EACvB,SAAS;AACX;AACA;IACI;QACI,sBAAsB;QACtB,kBAAkB;IACtB;AACJ;AACA,qCAAqC;AACrC;EACE;QACM,OAAO;QACP,YAAY;EAClB;EACA;QACM,qCAAqC;QACrC,YAAY;IAChB;AACJ;AACA;IACI;QACI,OAAO;QACP,YAAY;IAChB;IACA;QACI,qCAAqC;QACrC,YAAY;IAChB;IACA;QACI,WAAW;QACX,WAAW;IACf;AACJ;;AAEA,yBAAyB;AACzB;EACE,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,6DAA6D;EAC7D,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;EAC1C,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,4CAA4C;EAC5C,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sFAAsF;EACtF,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,wEAAwE;EACxE,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;EAC5C,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gEAAgE;EAChE,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,QAAQ;EACR,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE;IACE,qCAAqC;EACvC;EACA;IACE,2CAA2C;EAC7C;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI,qBAAqB;IACrB,oBAAoB;IACpB,gBAAgB;AACpB;AACA,gBAAgB;AAChB;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,oDAAoD;AACpD;EACE,0BAA0B;EAC1B,qCAAqC;EACrC,qCAAqC;EACrC,iCAAiC;AACnC;AACA;EACE,wCAAwC;EACxC,qCAAqC;EACrC,mDAAmD;AACrD;AACA;EACE,sDAAsD;EACtD,qCAAqC;AACvC;AACA;EACE,qDAAqD;EACrD,qCAAqC;AACvC;;AAEA;EACE,4CAA4C;EAC5C,kCAAkC;EAClC,gDAAgD;EAChD,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;AACA;EACE,qCAAqC;AACvC;;AAEA;;EAEE,+CAA+C;EAC/C,qCAAqC;EACrC,4CAA4C;AAC9C;;AAEA,qCAAqC;AACrC;;;EAGE,4CAA4C;EAC5C,4CAA4C;AAC9C;;AAEA;;;EAGE,qCAAqC;AACvC;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;EAEE,+CAA+C;EAC/C,gDAAgD;AAClD;;AAEA;;EAEE,6BAA6B;EAC7B,qCAAqC;AACvC;;AAEA;;;EAGE,qDAAqD;AACvD;;AAEA;EACE,+CAA+C;EAC/C,sBAAsB;AACxB;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA,kDAAkD;AAClD;EACE,4CAA4C;EAC5C,4CAA4C;AAC9C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+CAA+C;EAC/C,4CAA4C;AAC9C;;AAEA;EACE,4CAA4C;EAC5C,qCAAqC;EACrC,4CAA4C;AAC9C;;AAEA;EACE,mDAAmD;EACnD,qCAAqC;AACvC;;AAEA;EACE,qDAAqD;AACvD;;AAEA;;EAEE,+CAA+C;EAC/C,sBAAsB;AACxB;;AAEA;EACE,mDAAmD;AACrD;;AAEA;;;EAGE,yBAAyB;EACzB,wCAAwC;EACxC,gDAAgD;AAClD;;AAEA,iDAAiD;AACjD;;;;;;EAME,+CAA+C;EAC/C,qCAAqC;EACrC,4CAA4C;AAC9C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;;8CAE8C;;AAE9C,+BAA+B;AAC/B;EACE;IACE,+BAA+B;IAC/B,6BAA6B;EAC/B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA,sCAAsC;AACtC;EACE;IACE,+BAA+B;IAC/B,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA,uBAAuB;EACvB,KAAK,4BAA4B,EAAE;EACnC,KAAK,4BAA4B,EAAE;EACnC,KAAK,4BAA4B,EAAE;EACnC,WAAW,0BAA0B,EAAE;;EAEvC,uBAAuB;EACvB;IACE,oBAAoB;EACtB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA,4BAA4B;EAC5B;IACE,eAAe;IACf,SAAS;EACX;AACF;;AAEA,4CAA4C;AAC5C;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA,0BAA0B;EAC1B;IACE,0BAA0B;EAC5B;;EAEA,yBAAyB;EACzB;IACE,aAAa;EACf;;EAEA,UAAU;EACV;IACE,wBAAwB;EAC1B;AACF","sourcesContent":[":root {\n  --main-color: #0F1535;\n  --green-color: #d76420 ;\n  /* 713b14 */\n  --gray-color: #FFFFFF;\n  --body-color: #F1F5F9;\n  --text-color: #0D6EFD;\n  --sub-color: #222;\n  --basic-color: #fff;\n  --highlight-color: #F2205B;\n  --highlight-green: #7ba946;\n  --highlight-blue: #2858b4;\n  --text-lighter: #333;\n  --btn1-color: linear-gradient(90deg, #8824C2 0%, #F00488 100%);\n  --btn2-color: linear-gradient(90deg, #FF6A00 0%, #F01414 100%);\n  --input-bg: #dddddd40;\n  --border-color: #cccccc;\n  --shadow-light: 0px 4px 15px rgba(0, 0, 0, 0.05);\n  --dropdown-bg: #fafafa;\n  --top-nav: #d76420;\n  --green-transparent: #713b14;\n  --sidenav-width: 250px;\n}\n\nbody.dark-theme {\n  --main-color: #E2E8F0;\n  --green-color: #d76420;\n  --gray-color: #1E293B;\n  --body-color: #181d2a;\n  --text-color: #38BDF8;\n  --sub-color: #F8FAFC;\n  --basic-color: #1E293B;\n  --highlight-color: #F43F5E;\n  --highlight-green: #4ADE80;\n  --highlight-blue: #60A5FA;\n  --text-lighter: #CBD5E1;\n  --text-gray: #94A3B8;\n  --input-bg: #334155;\n  --border-color: #475569;\n  --shadow-light: 0px 4px 20px rgba(0, 0, 0, 0.4);\n  --dropdown-bg: #334155;\n  --top-nav: #1E293B;\n  --green-transparent: rgba(16, 185, 129, 0.2);\n  \n  /* Bootstrap Overrides */\n  --bs-body-color: var(--text-lighter);\n  --bs-heading-color: var(--text-lighter);\n  color: var(--text-lighter) !important;\n}\n\nbody.dark-theme .text-muted {\n  color: #94A3B8 !important;\n}\n\nbody {\n  transition: background-color 0.3s ease, color 0.3s ease;\n  overflow-x: hidden;\n}\n\n\n@font-face {\n  font-family: 'Janna';\n  src: url('./fonts/ArbFONTS-Janna-LT-Regular.woff2') format('woff2'),\n       url('./ArbFONTS-Janna-LT-Regular.ttf') format('truetype');\n  font-display: swap;\n  font-weight: 400;\n  font-style: normal;\n}\n\n::selection {\n  background-color: var(--green-color);\n  color: var(--basic-color);\n}\n\nbody::-webkit-scrollbar {\n  width: 10px;\n}\n\nbody::-webkit-scrollbar-track {\n  background: var(--basic-color);\n}\n\nbody::-webkit-scrollbar-thumb {\n  background-color: #ccc;\n  border-radius: 20px;\n  border: 1px solid #ddd;\n}\n\nbody {\n  margin: 0;\n  font-family: \"Janna\", sans-serif !important;\n  position: relative;\n  text-align: right !important;\n  background-color: var(--body-color) !important;\n  color: var(--text-lighter);\n}\n\n/* custom */\n.en-lang {\n  font-family: 'Nunito',sans-serif !important;\n  font-weight: bold !important;\n}\n.custom-font {font-family: 'janna',sans-serif !important;}\nbutton,\na {\n  cursor: pointer;\n}\n\n/* Global: show_all matches Bootstrap btn-warning */\n.show_all,\n.btn.show_all,\nbutton.show_all {\n  background-color: var(--bs-warning, #ffc107) !important;\n  border-color: var(--bs-warning, #ffc107) !important;\n  color: #000 !important;\n}\n\n.show_all:hover,\n.btn.show_all:hover,\nbutton.show_all:hover,\n.show_all:focus,\n.btn.show_all:focus,\nbutton.show_all:focus {\n  background-color: #ffca2c !important;\n  border-color: #ffc720 !important;\n  color: #000 !important;\n}\n\n.show_all:disabled,\n.btn.show_all:disabled,\nbutton.show_all:disabled {\n  background-color: var(--bs-warning, #ffc107) !important;\n  border-color: var(--bs-warning, #ffc107) !important;\n  color: #000 !important;\n  opacity: 0.65;\n}\n\nbutton:focus,\na:focus {\n  outline: none;\n}\n\nbutton:active,\nbutton:focus-visible,\nbutton:focus-within,\nbutton:focus,\nbutton:target {\n  border: none;\n}\n\na {\n  text-decoration: none !important;\n}\n\n.text-color {\n  color: var(--text-color) !important;\n}\n.main-color {\n  color: var(--green-color) !important;\n}\n\n.sub-text {\n  color: var(--sub-color) !important;\n}\n\n.text-lighter {\n  color: var(--text-lighter) !important;\n}\n\n.highlight-text {\n  color: var(--highlight-color) !important;\n}\n.highlight-green {color: var(--highlight-green) !important;}\n.highlight-blue {color: var(--highlight-blue) !important;}\n.text-gray {\n  color: var(--text-gray, #777);\n}\n.border-lighter {border: 1px solid #ffffff1f !important;}\n.text-lg {\n  font-size: large;\n}\n\n.text-md {\n  font-size: medium;\n}\n\n.text-sm {\n  font-size: small;\n}\n\n.text-xs {\n  font-size: x-small;\n}\n.text-custom {font-size: 12px;font-weight: bold;}\n.line-height {\n  line-height: 1.7em;\n}\n\n.b25 {\n  border-radius: 25px !important;\n}\n.div-bg {background-color: var(--basic-color);}\n.input-bg {\n  background-color: var(--input-bg) !important;\n  color: var(--sub-color) !important;\n  border-color: var(--border-color) !important;\n}\nselect {\n  cursor: pointer;\n  appearance: none;\n  background-image: url(../public/arrow.png) !important;\n  background-repeat: no-repeat;\n  background-size: 10px 10px;\n  border-radius: 5px;\n  background-position: left 14px center !important;\n  /* color: #ffffff80 !important; */\n}\n.file-input {overflow: hidden;position: relative;}\n.file-input__input {\n  width: 0.1px;\n  height: 0.1px;\n  opacity: 0;\n  overflow: hidden;\n  position: absolute;\n  z-index: -1;\n  width: 100%;\n}\n\n.file-input__label {\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  border-radius: 4px;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--basic-color);\n  font-size: 14px;\n  padding: 10px 12px;\n  background-color: var(--green-transparent);\n  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.25);\n  color: var(--green-color);\n  border: 1px solid var(--green-color);\n}\n.file_wrapper {\n  position: relative;\n    background-color: var(--basic-color);\n    border: 2px solid var(--green-color);\n    border-radius: 5px;\n    width: 200px;\n    height: 50px;\n    text-align: center;\n    overflow: hidden;\n    cursor: pointer;\n    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, .2);\n}\n.file_wrapper input {\n  background-color: aliceblue;\n  opacity: 0;\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 9;\n    cursor: pointer;\n}\n.file_wrapper label {\n  background-color: var(--basic-color);\n    width: 100%;\n    height: 100%;\n    margin: 0 !important;\n    position: absolute;\n    top: 0;\n    left: 0;\n    color: var(--green-color);\n    cursor: pointer;\n    font-weight: bold;\n    display: flex !important;\n    align-items: center;\n    justify-content: center;\n}\n.shadow-sm {\n  box-shadow: 0 .325rem .58rem rgba(0, 0, 0, 0.171) !important;\n}\n\n.file {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.file>input[type='file'] {\n  display: none\n}\n\n.file>label {\n  font-size: 1rem;\n  font-weight: 300;\n  cursor: pointer;\n  outline: 0;\n  user-select: none;\n  border-color: var(--main-color);\n  border-style: solid;\n  border-radius: 4px;\n  border-width: 1px;\n  background-color: #e0f2f1;\n  color: hsl(0, 0%, 29%);\n  padding-left: 16px;\n  padding-right: 16px;\n  padding-top: 9px;\n  padding-bottom: 7px;\n}\n\n.file--upload>label {\n  color: var(--main-color) !important;\n}\n.delete_file {\n position: absolute;\n    top: -10px;\n    left: -8px;\n    margin: 0 !important;\n    background-color: #ca4040 !important;\n    height: 20px;\n    width: 20px;\n    border-radius: 50% !important;\n    color: var(--basic-color) !important;\n}\n[dir='ltr'] .delete_file {right: -8px;left: unset;}\n/* handle pagination scroll */\n.pagination {\n  display: flex;\n  flex-wrap: nowrap; /* prevent wrapping */\n  overflow-x: auto;  /* enable horizontal scroll */\n  -webkit-overflow-scrolling: touch; /* smooth scroll on mobile */\n  scrollbar-width: thin; /* Firefox */\n  padding-block: 10px !important;\n}\n\n.pagination::-webkit-scrollbar {\n  height: 6px; /* horizontal scrollbar size */\n}\n\n.pagination::-webkit-scrollbar-thumb {\n  background: #aaa;\n  border-radius: 3px;\n}\n\n.page-item {\n  flex: 0 0 auto; /* keep each item fixed size, don't shrink */\n}\n.custom-tooltip {\n  background-color: #000 !important; \n  color: #fff !important; \n  font-weight: normal !important;  \n  border-radius: 4px;\n  padding: 4px 8px;\n}\n\n/* upload_photo */\n.upload_photo {\n      position: relative;\n    background-color: #e8f6f3;\n    width: 50px;\n    height: 50px;\n    text-align: center;\n    border: 1px dashed #ccc;\n    border-radius: 4px;\n    cursor: pointer;\n}\n.upload_photo img {\n  width: 40px;\n  height: 40px;\n  cursor: pointer;\n  object-fit: cover;\n  cursor: pointer;\n}\n.upload_photo input {\n    position: absolute;\n    top: 0;\n    height: 100% !important;\n    width: 100% !important;\n    right: 0;\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n    opacity: 0;\n    cursor: pointer;\n}\n.view_photo {\n      width: 50px;\n    height: 50px;\n    object-fit: cover;\n    border-radius: 3px;\n    margin-inline: 4px;\n}\n.custom-group {position: relative;display: inline-block;}\n.custom-group input {\n  padding: 0;\n  height: initial;\n  width: initial;\n  margin-bottom: 0;\n  display: none;\n  cursor: pointer;\n}\n\n.custom-group label {\n  position: relative;\n  cursor: pointer;\n  display: inline-block;\n}\n\n.custom-group label:before {\n  content:'';\n  -webkit-appearance: none;\n  appearance: none;\n  background-color: transparent;\n  border: 2px solid var(--green-color);\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05), inset 0px -15px 10px -12px rgba(0, 0, 0, 0.05);\n  padding: 10px;\n  display: inline-block;\n  position: relative;\n  vertical-align: middle;\n  cursor: pointer;\n}\n\n.custom-group input:checked + label:after {\n  content: '';\n  display: block;\n  position: absolute;\n  top: 3px;\n  right: 9px;\n  width: 6px;\n  height: 14px;\n  border: solid var(--green-color);\n  border-width: 0 2px 2px 0;\n  transform: rotate(45deg);\n}\n/* styled checkbox */\n.styled_checkbox {\n  display: flex !important;\n  align-items: center;\n  flex-direction: row-reverse;\n  justify-content: flex-end;\n  border: 1px solid #ddd;\n  padding: 10px;\n  border-radius: 5px;\n  cursor: pointer;\n  box-shadow: 0px 2px 5px 0px #eee;\n}\n.styled_checkbox input {\n  height: auto !important;\n  width: auto !important;\n  accent-color: var(--green-color);\n  margin: 0px 10px !important;\n}\n.rd3t-label__title,\n.rd3t-label__attributes,.rd3t-node,.rd3t-leaf-node {\n  stroke: #ffffff !important;\n  stroke-width: 0 !important;\n}\n.flow-skeleton {\n  fill: #e0e0e0;\n  stroke: #d0d0d0;\n  animation: shimmer 1.6s infinite linear;\n}\n\n.flow-line {\n  stroke: #d0d0d0;\n  stroke-width: 2;\n  stroke-dasharray: 6;\n  opacity: 0.6;\n}\n\n@keyframes shimmer {\n  0% {\n    fill: #e0e0e0;\n  }\n  50% {\n    fill: #f5f5f5;\n  }\n  100% {\n    fill: #e0e0e0;\n  }\n}\n\n/* form style */\n.form-style label {\n  display: block;\n  margin: 10px 0;\n}\n.form-style label.text-light {color: var(--sub-color) !important;font-weight: bold;}\n.form-style input:not(.no-class),\n.form-style select \n{\n  padding: 10px;\n  width: 100%;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  background-color: var(--basic-color);\n  /* height: 40px; */\n  margin: 5px 0;\n  font-size: 13px;\n}\n\n.form-style textarea {\n  padding: 0px 10px;\n  background-color: var(--basic-color);\n  width: 100%;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  margin: 8px 0;\n  font-size: 13px;\n}\n.form-style input:not(.no-class),.form-style textarea {color: var(--text-lighter);}\n.form-style input:not(.no-class)::placeholder,\n.form-style textarea::placeholder {\n  color: #333;\n  font-size: 14px;\n}\n\n.form-style input:not(.no-class):focus,\n.form-style textarea:focus,\n.form-style select:focus {\n  outline: none;\n  border: 1px solid var(--green-color);\n  box-shadow: 0 0 5px rgba(16, 185, 129, 0.3);\n}\n.no_data h5 {text-align: center !important;}\n.input-no-class {\n  height: auto !important;\n  width: auto !important;\n  box-shadow: none !important;\n}\n/* login & register */\n.form-div {\n  width:400px;\n  max-width:90%;\n  padding:20px;\n  border-radius:7px;\n  margin:20px auto;\n  background-color:var(--basic-color);\n  box-shadow:0px 4px 7px 4px #ddd;\n}\n.form-div button[type=\"submit\"] {\n  color:var(--basic-color);\n  border:none;\n  background-color:var(--green-color);\n  border-radius:5px;\n  padding-block:8px;\n  margin-block:10px !important;\n}\n.form-div button:focus {outline:none}\n.form-div label {font-weight:bold;}\n.form-div input::placeholder {color:#ddd;font-size:12px;}\n.form-div input:focus {border-color:var(--green-color);}\n.form-div h5 {color:var(--green-color);font-weight:bold;text-align:center;margin-bottom:15px;}\n  .react-select__control:hover, .react-select__control:focus,\n  .react-select__control--is-focused\n  {border-color: var(--main-color) !important;box-shadow: none !important;}\n.css-1dimb5e-singleValue,.css-1jqq78o-placeholder{font-size: 13px;}\n.css-13cymwt-control {background-color: var(--basic-color);}\n/* .react-select__control {\n  min-height:36px !important;\n  height:36px !important;\n}\n\n.react-select__value-container {\n  height:36px;\n  padding: 0 8px;\n}\n\n.react-select__indicators {\n  height: 36px;\n}\n.react-select__input-container input {height: inherit !important;} */\n.custom-input-file {\n  position: relative;\n    background: aliceblue;\n    overflow: hidden;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n    height: 41px;\n}\n.custom-input-file span {\n    padding-inline: 10px;\n    padding-block: 10px;\n    font-size: .8em;\n    display: block;\n}\n.custom-input-file input {\n  height: 100%;\n  margin: 0 !important;\n    position: absolute;\n    background: aliceblue;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    opacity: 0;\n}\n.remove_row {\n  height: 30px;\n  width: 30px;\n  text-align: center;\n  padding: 2px 0 0 !important;\n  margin-top: 36px !important;\n}\n.react-select__menu {font-size: small;}\n.custom-span1 {\n      background-color: #e8c65d;\n    color: #d76420;\n    font-weight: bold;\n    padding: 4px 20px;\n    display: inline-block;\n    border-radius: 25px;\n    \n}\n.custom-span2 {\n  background-color: #a5d6cc;\n    color: var(--green-color);\n    font-weight: bold;\n    padding: 4px 20px;\n    display: inline-block;\n    border-radius: 25px;\n}\n/* topnav */\n.topnav {\n  background-color: #fff;\n  padding-inline-end: 0;\n  padding-inline-start: 0;\n  transition: all 0.3s ease-in-out;\n  box-shadow: var(--shadow-light);\n  border-bottom: 1px solid #e9ecef;\n}\n\n.topnav .text-light,\n.topnav .toggle_sidenav .text-light,\n.topnav .actions .text-light,\n.topnav a.text-white {\n  color: #212529 !important;\n}\n.topnav .dropdown-menu-end[data-bs-popper] {\n    left: 0;\n    right: auto;\n}\n.topnav .actions {\n  padding: 0;\n  list-style: none;\n  margin: 0;\n  display: flex;\n  align-items: center;\n}\n\n.topnav .actions .dropdown-toggle::after {\n  display: none;\n}\n\n.topnav .actions li {\n  margin-inline: 3px;\n  cursor: pointer;\n}\n\n.topnav .actions .dropdown-menu {\n  text-align: right;\n  font-size: 12px;\n}\n\n.topnav .actions li img {\n  width: auto;\n  max-height: 23px;\n  object-fit: cover;\n}\nbutton.notification {position: relative;}\nbutton.notification span {\n  position: absolute;\n    background-color: red;\n    color: #fff;\n    height: 17px;\n    width: 17px;\n    border-radius: 50%;\n    font-size: 10px;\n    top: -3px;\n    right: 0;\n    padding-top: 2px;\n}\n.topnav .dropdown-item {font-weight:bold;}\n\n.topnav-user-toggle {\n  display: inline-flex;\n  align-items: center;\n  padding: 0;\n}\n\n.topnav-user-avatar {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 2px solid rgba(255, 255, 255, 0.85);\n  background: #fff;\n}\n\n.topnav-user-menu {\n  min-width: 240px;\n  padding-top: 0.35rem;\n  padding-bottom: 0.35rem;\n}\n\n.topnav-user-menu__header {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.65rem 1rem;\n  pointer-events: none;\n}\n\n.topnav-user-menu__avatar {\n  width: 42px;\n  height: 42px;\n  border-radius: 50%;\n  object-fit: cover;\n  flex-shrink: 0;\n  border: 1px solid #dee2e6;\n}\n\n.topnav-user-menu__info {\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n  min-width: 0;\n}\n\n.topnav-user-menu__name {\n  font-size: 0.875rem;\n  font-weight: 700;\n  color: #212529;\n  line-height: 1.3;\n  word-break: break-word;\n}\n\n.topnav-user-menu__email {\n  font-size: 0.75rem;\n  color: #6c757d;\n  word-break: break-all;\n}\n\n/* sidenav */\n.sidenav {\n  background-color: var(--basic-color);\n  width: var(--sidenav-width);\n  box-sizing: border-box;\n  max-width: 100vw;\n  height: 100%;\n  position: fixed;\n  top: 0;\n  right: 0;\n  padding: 10px 20px;\n  overflow-x: hidden;\n  overflow-y: scroll;\n  transition: all .3s ease-in-out;\n  box-shadow: var(--shadow-light);\n  z-index: 1040;\n}\n\n.sidenav .dropdown-menu.show {\n  display: block !important;\n  position: static !important;\n  float: none !important;\n  transform: none !important;\n  inset: auto !important;\n  margin-top: 5px !important;\n}\n\n.sidenav .sidenav-submenu {\n  list-style: none;\n  margin-block: 5px;\n}\n\n.sidenav .sidenav-submenu > .sidenav-submenu__toggle {\n  display: flex !important;\n  align-items: center;\n  gap: 2px;\n  width: 100%;\n  position: relative;\n  padding: 6px 10px;\n  padding-inline-end: 1.75rem;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: bold;\n  color: var(--text-gray, #777);\n  background: transparent !important;\n  cursor: pointer;\n  white-space: pre-wrap;\n}\n\n.sidenav .sidenav-submenu > .sidenav-submenu__toggle:hover {\n  background: transparent !important;\n  color: var(--text-gray, #777) !important;\n}\n\n.sidenav .sidenav-submenu.active > .sidenav-submenu__toggle,\n.sidenav .sidenav-submenu.show > .sidenav-submenu__toggle {\n  background: transparent !important;\n  color: var(--text-gray, #777) !important;\n}\n\n.sidenav .sidenav-submenu > .sidenav-submenu__toggle::after {\n  inset-inline-start: auto;\n  inset-inline-end: 8px;\n  left: auto;\n  right: 8px;\n  top: 50%;\n  transform: translateY(-50%) rotate(0deg);\n  width: 11px;\n  height: 11px;\n  opacity: 0.75;\n  transition: transform 0.2s ease, opacity 0.2s ease;\n}\n\n[dir=\"ltr\"] .sidenav .sidenav-submenu > .sidenav-submenu__toggle::after {\n  right: auto;\n  left: 8px;\n}\n\n.sidenav .sidenav-submenu.show > .sidenav-submenu__toggle::after {\n  transform: translateY(-50%) rotate(-90deg);\n  opacity: 1;\n}\n\n[dir=\"ltr\"] .sidenav .sidenav-submenu.show > .sidenav-submenu__toggle::after {\n  transform: translateY(-50%) rotate(90deg);\n}\n\n.sidenav .sidenav-submenu__menu.dropdown-menu {\n  display: none;\n  margin: 4px 0 2px !important;\n  margin-inline-start: 0.85rem !important;\n  padding: 0 !important;\n  width: calc(100% - 0.85rem);\n  border: none;\n  border-radius: 0;\n  background: transparent !important;\n  box-shadow: none;\n}\n\n.sidenav .sidenav-submenu.show > .sidenav-submenu__menu.dropdown-menu {\n  display: block !important;\n}\n\n.sidenav .sidenav-submenu__menu > li {\n  margin-block: 5px !important;\n}\n\n.sidenav .sidenav-submenu__menu > li > .dropdown-item {\n  font-size: 12px;\n  font-weight: bold;\n  color: #777;\n  white-space: pre-wrap;\n  display: flex;\n  background: transparent;\n}\n\n.sidenav .sidenav-submenu__menu > li > .dropdown-item:hover,\n.sidenav .sidenav-submenu__menu > li.active > .dropdown-item,\n.sidenav .sidenav-submenu__menu > li > .sidenav-submenu__item--active {\n  background-color: var(--green-color) !important;\n  color: var(--basic-color) !important;\n}\n\nbody.dark-theme .sidenav .sidenav-submenu__menu.dropdown-menu,\nbody.dark-theme .sidenav .sidenav-submenu > .sidenav-submenu__toggle,\nbody.dark-theme .sidenav .sidenav-submenu.active > .sidenav-submenu__toggle,\nbody.dark-theme .sidenav .sidenav-submenu.show > .sidenav-submenu__toggle {\n  background: transparent !important;\n  color: var(--text-gray, #94a3b8) !important;\n}\n\n.sidenav .dropdown-menu {\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n  background-color: var(--dropdown-bg);\n  text-align: right;\n  font-size: small;\n  padding-block: 7px;\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n}\n\n.sidenav .dropdown-toggle::after {\n  left: 0px;\n  position: absolute;\n  top: 13px;\n  content: \"\";\n  display: inline-block;\n  width: 13px;\n  height: 13px;\n  background-image: url('../public/arrow.png');\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n  margin-inline-start: 8px;\n  vertical-align: middle;\n  border: unset;\n  transition: all .3s ease-in-out;\n}\n\n.sidenav .dropdown-menu a span {\n  color: var(--sub-color);\n}\n\n.sidenav::-webkit-scrollbar {\n  width: 3px;\n}\n\n.sidenav::-webkit-scrollbar-track {\n  background: #ccc;\n}\n\n.sidenav::-webkit-scrollbar-thumb {\n  background-color: #eeeeee40;\n  border-radius: 20px;\n  border: 1px solid #ddd;\n}\n\n.sidenav .main-ul {\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: column;\n}\n\n.sidenav ul {\n  padding: 0;\n}\n\n.sidenav li {\n  margin-block: 5px;\n  font-size: 14px;\n  transition: all .3s ease-in-out;\n}\n.sidenav .dropdown-menu li a {\n  color: var(--text-lighter);\n  font-size: 11px;\n}\n\n/* ——— قائمة الإعدادات (بحث + عناصر) ——— */\n.sidenav .dropdown-menu.sidenav-settings-menu {\n  max-height: min(70vh, 520px);\n  overflow-y: auto;\n}\n\n.sidenav-settings-menu > li {\n  margin-block: 0 !important;\n  list-style: none;\n}\n\n.sidenav-settings-menu__head {\n  position: sticky;\n  top: 0;\n  z-index: 3;\n  padding: 10px 10px 8px;\n  background: linear-gradient(\n    180deg,\n    var(--dropdown-bg) 0%,\n    rgba(215, 100, 32, 0.06) 100%\n  );\n  border-bottom: 1px solid rgba(215, 100, 32, 0.18);\n}\n\n.sidenav-settings-menu__head-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.sidenav-settings-menu__head-title {\n  font-size: 12px;\n  font-weight: 700;\n  color: var(--green-color);\n}\n\n.sidenav-settings-menu__count {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 1.65rem;\n  padding: 2px 7px;\n  border-radius: 999px;\n  font-size: 10px;\n  font-weight: 700;\n  line-height: 1.2;\n  color: var(--green-color);\n  background: rgba(215, 100, 32, 0.14);\n  border: 1px solid rgba(215, 100, 32, 0.22);\n}\n\n.sidenav-settings-menu__search-wrap {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.sidenav-settings-menu__search-icon {\n  position: absolute;\n  inset-inline-start: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 0.8rem;\n  color: #94a3b8;\n  pointer-events: none;\n  z-index: 1;\n}\n\n.sidenav-settings-menu__search-input {\n  width: 100%;\n  height: 34px;\n  padding-inline-start: 2rem;\n  padding-inline-end: 2rem;\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--text-lighter);\n  background: var(--basic-color);\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.sidenav-settings-menu__search-input::placeholder {\n  color: #94a3b8;\n  font-weight: 400;\n}\n\n.sidenav-settings-menu__search-input:focus {\n  outline: none;\n  border-color: var(--green-color);\n  box-shadow: 0 0 0 3px rgba(215, 100, 32, 0.18);\n}\n\n.sidenav-settings-menu__search-clear {\n  position: absolute;\n  inset-inline-end: 6px;\n  top: 50%;\n  transform: translateY(-50%);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  border: none;\n  background: transparent;\n  color: #94a3b8;\n  font-size: 0.95rem;\n  line-height: 1;\n  cursor: pointer;\n  transition: color 0.15s ease;\n}\n\n.sidenav-settings-menu__search-clear:hover {\n  color: var(--green-color);\n}\n\n.sidenav-settings-menu__empty {\n  margin-block: 4px !important;\n}\n\n.sidenav-settings-menu__empty .dropdown-item-text {\n  display: block;\n  padding: 8px 12px;\n  font-size: 11px;\n  color: #6c757d;\n  text-align: center;\n}\n\nbody.dark-theme .sidenav-settings-menu__search-input {\n  background: var(--input-bg);\n  color: var(--text-lighter);\n  border-color: var(--border-color);\n}\n\nbody.dark-theme .sidenav-settings-menu__search-input::placeholder {\n  color: var(--text-gray, #94a3b8);\n}\n\n.sidenav .dropdown-menu li {\n  margin-block: 5px;\n  transition: all .3s ease-in-out;\n}\n\n.sidenav .dropdown-menu li a:hover {\n  background-color: var(--green-color);\n  color: var(--basic-color);\n}\n\n.sidenav .dropdown-menu li a {\n  transition: all .3s ease-in-out;\n}\n.sidenav li a:not(.dropdown-item) {\n  display: block;\n      padding: 6px;\n    border-radius: 5px;\n     transition: all .3s ease-in-out;\n}\n.sidenav li.active a:not(.dropdown-item) {\n  background-color: #d76420;\n    color: var(--basic-color) !important;\n}\n.sidenav li svg {\n  width: auto;\n  max-height: 30px;\n  margin-left: 3px;\n   transition: all .3s ease-in-out;\n}\n.sidenav li span {display: flex;align-items: center;font-weight: bold;transition: all .3s ease-in-out;}\n.sidenav li a.dropdown-toggle {font-weight: bold;transition: all .3s ease-in-out;}\n.sidenav li.active a.dropdown-toggle {\n    background-color: #d76420;\n    color: var(--basic-color) !important;\n    /* color: #777 !important; */\n}\n.sidenav li.active .dropdown-toggle::after {mix-blend-mode: color-dodge;}\n.sidenav li.active span {color: var(--basic-color);}\n.sidenav li.active img {mix-blend-mode: color-dodge;}\n.sidenav .dropdown-menu li a {\n    font-size: 12px;\n    font-weight: bold;\n    color: #777;\n    white-space: pre-wrap;\n    display: flex;\n}\n\n/* Bonds toggle only: avoid white text from li.active; children use normal dropdown styles */\n.sidenav .dropdown-menu .sidenav-submenu > .sidenav-submenu__toggle,\n.sidenav .dropdown-menu .sidenav-submenu.active > .sidenav-submenu__toggle,\n.sidenav .dropdown-menu .sidenav-submenu.show > .sidenav-submenu__toggle,\n.sidenav li.active .dropdown-menu .sidenav-submenu > .sidenav-submenu__toggle,\n.sidenav li.active .dropdown-menu .sidenav-submenu.active > .sidenav-submenu__toggle {\n  background: transparent !important;\n  color: #777 !important;\n}\n\n.sidenav .dropdown-menu .sidenav-submenu > .sidenav-submenu__toggle .sidenav-submenu__label,\n.sidenav .dropdown-menu .sidenav-submenu.active > .sidenav-submenu__toggle .sidenav-submenu__label,\n.sidenav li.active .dropdown-menu .sidenav-submenu > .sidenav-submenu__toggle span.sidenav-submenu__label {\n  color: #777 !important;\n}\n\n.sidenav .dropdown-menu .sidenav-submenu__menu > li > a.dropdown-item {\n  font-size: 12px;\n  font-weight: bold;\n  color: #777;\n  background: transparent;\n}\n\n.sidenav .dropdown-menu .sidenav-submenu__menu > li > a.dropdown-item:hover,\n.sidenav .dropdown-menu .sidenav-submenu__menu > li > a.sidenav-submenu__item--active,\n.sidenav .dropdown-menu .sidenav-submenu__menu > li.active > a.dropdown-item {\n  background-color: var(--green-color) !important;\n  color: var(--basic-color) !important;\n}\n\nbody.dark-theme .sidenav .dropdown-menu .sidenav-submenu > .sidenav-submenu__toggle,\nbody.dark-theme .sidenav .dropdown-menu .sidenav-submenu.active > .sidenav-submenu__toggle,\nbody.dark-theme .sidenav li.active .dropdown-menu .sidenav-submenu > .sidenav-submenu__toggle span.sidenav-submenu__label {\n  color: var(--text-gray, #94a3b8) !important;\n  background: transparent !important;\n}\n/* Layout main — padding بعرض السايدبار والسايدبار ثابت يمين */\n.app-layout__main {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  width: 100%;\n  box-sizing: border-box;\n  transition: padding 0.3s ease-in-out;\n}\n\n.app-layout__main.full-width,\nbody.sidenav-docked-closed .app-layout__main {\n  padding: 0 !important;\n}\n\n/* content wrapper — يبدأ مباشرة بعد عرض السايدبار */\n.content_wrapper {\n  padding-inline: 12px;\n  margin-block: 20px;\n  transition: margin 0.3s ease-in-out, width 0.3s ease-in-out, max-width 0.3s ease-in-out;\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n  position: relative;\n  z-index: 1;\n  margin-inline: 0;\n}\n\n/* السايدبار مغلق أو overlay (موبايل) — المحتوى بعرض الشاشة كامل */\n.content_wrapper.full-width,\nbody.sidenav-docked-closed .content_wrapper {\n  margin-inline: 0 !important;\n  width: 100% !important;\n  max-width: 100% !important;\n}\n\n/* @media (max-width: 500px) {\n  .topnav .dropdown-menu-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n}\n} */\n .modal-body {font-weight: bold;}\n .accordion-button {margin: 0 !important;}\n .accordion-button::after\n {\n  background-size: 17px !important;\n  margin-right: auto;\n  margin-left: unset !important;\n  transform: unset !important;\n  background-image: url('../public/plus.png') !important;\n}\n.accordion-button:not(.collapsed)::after\n {\n  background-size: 17px !important;\n  margin-right: auto;\n  margin-left: unset !important;\n  background-image: url('../public/minus.png') !important;\n  transform: unset !important;\n}\n\n.accordion-button:not(.collapsed)\n{\n  background-color: #eee !important;\n}\n.accordion-button h5 {\n  font-size: 17px;\n    font-weight: bold;\n    color: #333;\n}\n.accordion-button:focus {box-shadow: none !important;border: none;}\n@media (min-width: 1191px) {\n  .sidenav.openNav {\n    right: 0;\n  }\n\n  .sidenav.closedNav {\n    right: calc(-1 * var(--sidenav-width));\n  }\n\n  html[dir=\"rtl\"] .app-layout__main.with-sidenav,\n  html[dir=\"rtl\"] body.sidenav-docked-open .app-layout__main,\n  [dir=\"rtl\"] .app-layout__main.with-sidenav,\n  [dir=\"rtl\"] body.sidenav-docked-open .app-layout__main {\n    padding-right: var(--sidenav-width);\n    padding-left: 0;\n  }\n\n  html[dir=\"ltr\"] .app-layout__main.with-sidenav,\n  html[dir=\"ltr\"] body.sidenav-docked-open .app-layout__main,\n  [dir=\"ltr\"] .app-layout__main.with-sidenav,\n  [dir=\"ltr\"] body.sidenav-docked-open .app-layout__main {\n    padding-left: var(--sidenav-width);\n    padding-right: 0;\n  }\n\n  .app-layout__main.with-sidenav > .content_wrapper > .container {\n    max-width: 100%;\n    width: 100%;\n    padding-inline: 0;\n  }\n\n  .closeNav {\n    display: none;\n  }\n}\n\n@media (max-width: 1190px) {\n  .sidenav {\n    right: calc(-1 * var(--sidenav-width)); /* default closed */\n  }\n\n  .sidenav.openNav {\n    right: 0;\n  }\n\n  .sidenav.closedNav {\n    right: calc(-1 * var(--sidenav-width));\n  }\n\n  .content_wrapper {\n    margin-inline-end: 0 !important;\n    margin-inline-start: 0 !important;\n    width: 100% !important;\n  }\n\n  .app-layout__main,\n  .app-layout__main.with-sidenav {\n    padding: 0 !important;\n  }\n\n  .topnav {\n    padding-right: 0 !important;\n  }\n\n  .closeNav {\n    display: block;\n    color: var(--sub-color);\n    position: absolute;\n    left: 10px;\n    top: 10px;\n    font-size: 24px;\n    cursor: pointer;\n  }\n  \n}\n@media(max-width:410px) \n{\n  .navbar>.container {flex-wrap: nowrap !important;}\n}\n/* end media */\n.sidenav {\n  background-color: var(--gray-color);\n  width: var(--sidenav-width);\n  box-sizing: border-box;\n  max-width: 100vw;\n  height: 100%;\n  position: fixed;\n  top: 0;\n  right: 0;\n  padding: 10px 20px;\n  overflow-x: hidden;\n  overflow-y: auto;\n  transition: all 0.3s ease-in-out;\n  z-index: 1040;\n}\n\n.content_wrapper {\n  transition: all 0.3s ease-in-out;\n  padding-inline: 12px;\n  margin-block: 20px;\n}\n\n.topnav {\n  background-color: #fff;\n  transition: all 0.3s ease-in-out;\n  padding-top: 16px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid #e9ecef;\n}\n.fixed-top {padding-top: 10px !important;padding-bottom: 10px !important;z-index: 2 !important;}\n.topnav--modern.fixed-top {z-index: 1030 !important;}\n/* ######### [dir ltr] ########## */\n\n@font-face {\n  font-family: 'Nunito';\n  src: url('./fonts/Nunito-Regular.woff2') format('woff2'),\n       url('./Nunito-Regular.ttf') format('truetype');\n  font-display: swap;\n  font-weight: 400;\n  font-style: normal;\n}\n[dir=\"ltr\"] body {\n  text-align: left;\n  font-family: 'Nunito', sans-serif !important;\n  direction: ltr !important;\n}\n[dir=\"ltr\"] .sidenav li {\n        text-align: left;\n}\n[dir=\"ltr\"] .sidenav li svg {margin-right: 3px;margin-left: 0 !important;}\n[dir=\"ltr\"] .sidenav .dropdown-toggle::after {\n  right: 0px;\n  left: unset;\n  margin-inline-start: 0px;\n  margin-inline-end: 8px;\n}\n[dir=\"ltr\"] .sidenav .dropdown-menu li a i::before {\n  transform: rotate(180deg);\n  margin-right: 2px !important;\n  margin-left: 0 !important;\n}\n[dir=\"ltr\"] .sidenav li img {margin-right: 3px;margin-left: 0px;}\n[dir=\"ltr\"] .topnav .dropdown-menu-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n}\n[dir=\"ltr\"] .topnav .dropdown-menu,\n[dir=\"ltr\"] .providers_on_map h5\n {text-align: left;}\n [dir=\"ltr\"] .table_form b\n {text-align: left;}\n [dir=\"ltr\"] .circle_chart b, [dir=\"ltr\"] .circle_chart h5 {\n    margin-left: 5px;\n    margin-right: 0px;\n    text-align: left;\n}\n[dir=\"ltr\"] .topnav .actions li a ,\n[dir=\"ltr\"] .topnav .actions li ul button {font-weight: bold;font-size: 13px;}\n[dir=\"ltr\"] .stat_card,\n[dir=\"ltr\"] .table_form label,\n[dir=\"ltr\"] .table_form select\n {text-align: left;}\n[dir=\"ltr\"] .stat_card img {\n  transform: scalex(-1);\n}\n[dir=\"ltr\"] .accordion-button::after {margin-left: auto !important;margin-right: unset !important;}\n[dir=\"ltr\"] .sidenav .dropdown-menu li a {font-size: 12px;}\n[dir=\"ltr\"] select {background-position: right 14px center !important;}\n[dir=\"ltr\"] .chart-text {font-family: 'Nunito',sans-serif !important;}\n.ar-lang {font-weight: bold !important;}\n[dir=\"ltr\"] .ar-lang {font-family: 'Janna',sans-serif !important;}\n[dir=\"ltr\"] .chart-text {border-left: 1px solid #eeeeee26;border-right:none}\n[dir=\"ltr\"] .pagination .page-item:first-child .page-link {\n    border-radius: 50%;\n    border-top-right-radius: var(--bs-pagination-border-radius);\n    border-bottom-right-radius: var(--bs-pagination-border-radius);\n}\n[dir=\"ltr\"] .pagination .page-item:last-child .page-link {\n    border-radius: 50%;\n    border-top-left-radius: var(--bs-pagination-border-radius);\n    border-bottom-left-radius: var(--bs-pagination-border-radius);\n}\n[dir=\"ltr\"] .pagination .page-item .page-link i {transform: rotate(180deg);}\n[dir=\"ltr\"] .view,[dir=\"ltr\"] .toggle {text-align: left;}\n[dir=\"ltr\"] .table_form label{font-weight: bold;font-size: 14px;}\n.toggle {float: right;}\n[dir=\"ltr\"] .toggle {float: left;}\n[dir=\"ltr\"] .btn {font-weight: bold;}\n[dir=\"ltr\"] .modal-body ,\n[dir=\"ltr\"] .tab-content ,\n[dir=\"ltr\"] .form-style ,\n[dir=\"ltr\"] h5 ,\n[dir=\"ltr\"] h3\n{text-align: left;}\n[dir=\"ltr\"] .custom-radio {margin-right: 0 !important;margin-left: 10px !important;}\n[dir=\"ltr\"] .text-custom {font-weight: bold;}\n[dir=\"ltr\"] .content_wrapper .table tbody tr  td {font-weight: bold;}\n[dir=\"ltr\"] .sidenav .dropdown-toggle::after {top: 10px;}\n.total_amounts {text-align: left;}\n[dir=\"ltr\"] .total_amounts {text-align: right;}\n[dir=\"ltr\"] .custom-group input:checked + label:after {\n  right: unset !important;\n  left: 9px;\n}\n@media (max-width: 500px) {\n    [dir=\"rtl \"] .topnav .dropdown-menu-end[data-bs-popper] {\n        right: auto !important;\n        left: 0 !important;\n    }\n}\n/* ####### media [dir=\"ltr\"] ###### */\n@media (min-width: 1191px) {\n  [dir=\"ltr\"] .sidenav.openNav {\n        left: 0;\n        right: unset;\n  }\n  [dir=\"ltr\"] .sidenav.closedNav {\n        left: calc(-1 * var(--sidenav-width));\n        right: unset;\n    }\n}\n@media (max-width: 1190px) {\n    [dir=\"ltr\"] .sidenav.openNav {\n        left: 0;\n        right: unset;\n    }\n    [dir=\"ltr\"] .sidenav.closedNav {\n        left: calc(-1 * var(--sidenav-width));\n        right: unset;\n    }\n    [dir=\"ltr\"] .closeNav {\n        right: 10px;\n        left: unset;\n    }\n}\n\n/* NotFound Page Styles */\n.not-found-container {\n  min-height: calc(100vh - 0px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem;\n  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);\n  position: relative;\n  overflow: hidden;\n}\n\n.not-found-wrapper {\n  position: relative;\n  z-index: 1;\n  width: 100%;\n  max-width: 700px;\n}\n\n.not-found-content {\n  background: var(--basic-color);\n  border-radius: 24px;\n  padding: 3rem 2rem;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.1);\n  text-align: center;\n  position: relative;\n  overflow: hidden;\n  animation: fadeInUp 0.6s ease-out;\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.not-found-illustration {\n  position: relative;\n  margin-bottom: 2rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 200px;\n}\n\n.error-code {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  font-size: 8rem;\n  font-weight: 900;\n  color: var(--green-color);\n  line-height: 1;\n  position: relative;\n  z-index: 2;\n  animation: bounce 2s infinite;\n}\n\n.error-digit {\n  display: inline-block;\n  position: relative;\n  text-shadow: 0 4px 8px rgba(0, 106, 83, 0.2);\n  transition: transform 0.3s ease;\n}\n\n.error-digit.middle {\n  animation: pulse 1.5s infinite;\n}\n\n@keyframes bounce {\n  0%, 100% {\n    transform: translateY(0);\n  }\n  50% {\n    transform: translateY(-10px);\n  }\n}\n\n@keyframes pulse {\n  0%, 100% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.1);\n  }\n}\n\n.error-icon-wrapper {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 1;\n  opacity: 0.1;\n}\n\n.error-icon {\n  font-size: 15rem;\n  color: var(--green-color);\n  animation: rotate 20s linear infinite;\n}\n\n@keyframes rotate {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.not-found-text {\n  margin-bottom: 2.5rem;\n}\n\n.not-found-title {\n  font-size: 2rem;\n  font-weight: 700;\n  color: var(--main-color);\n  margin-bottom: 1rem;\n  line-height: 1.2;\n}\n\n.not-found-message {\n  font-size: 1rem;\n  color: var(--text-lighter);\n  line-height: 1.6;\n  max-width: 500px;\n  margin: 0 auto;\n}\n\n.not-found-actions {\n  display: flex;\n  gap: 1rem;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.btn-not-found {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.875rem 2rem;\n  border-radius: 12px;\n  font-weight: 600;\n  font-size: 1rem;\n  text-decoration: none;\n  border: none;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n.btn-not-found::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);\n  transition: left 0.5s ease;\n}\n\n.btn-not-found:hover::before {\n  left: 100%;\n}\n\n.btn-primary-not-found {\n  background: linear-gradient(135deg, var(--green-color) 0%, #005a47 100%);\n  color: var(--basic-color);\n  box-shadow: 0 4px 15px rgba(0, 106, 83, 0.3);\n}\n\n.btn-primary-not-found:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(0, 106, 83, 0.4);\n  color: var(--basic-color);\n}\n\n.btn-secondary-not-found {\n  background: var(--basic-color);\n  color: var(--green-color);\n  border: 2px solid var(--green-color);\n}\n\n.btn-secondary-not-found:hover {\n  background: var(--green-color);\n  color: var(--basic-color);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 15px rgba(0, 106, 83, 0.2);\n}\n\n.btn-icon {\n  font-size: 1.25rem;\n  transition: transform 0.3s ease;\n}\n\n.btn-not-found:hover .btn-icon {\n  transform: translateX(4px);\n}\n\n.btn-not-found:hover .btn-icon.rotate {\n  transform: translateX(-4px);\n}\n\n.not-found-decoration {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  z-index: 0;\n}\n\n.decoration-circle {\n  position: absolute;\n  border-radius: 50%;\n  background: linear-gradient(135deg, var(--green-color), #005a47);\n  opacity: 0.1;\n  animation: float 6s ease-in-out infinite;\n}\n\n.circle-1 {\n  width: 200px;\n  height: 200px;\n  top: -100px;\n  right: -100px;\n  animation-delay: 0s;\n}\n\n.circle-2 {\n  width: 150px;\n  height: 150px;\n  bottom: -75px;\n  left: -75px;\n  animation-delay: 2s;\n}\n\n.circle-3 {\n  width: 100px;\n  height: 100px;\n  top: 50%;\n  right: 10%;\n  animation-delay: 4s;\n}\n\n@keyframes float {\n  0%, 100% {\n    transform: translateY(0) rotate(0deg);\n  }\n  50% {\n    transform: translateY(-20px) rotate(180deg);\n  }\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .not-found-container {\n    padding: 1rem;\n    min-height: calc(100vh - 80px);\n  }\n\n  .not-found-content {\n    padding: 2rem 1.5rem;\n  }\n\n  .error-code {\n    font-size: 5rem;\n  }\n\n  .error-icon {\n    font-size: 10rem;\n  }\n\n  .not-found-title {\n    font-size: 1.5rem;\n  }\n\n  .not-found-message {\n    font-size: 0.9rem;\n  }\n\n  .btn-not-found {\n    padding: 0.75rem 1.5rem;\n    font-size: 0.9rem;\n  }\n\n  .not-found-actions {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .btn-not-found {\n    width: 100%;\n    justify-content: center;\n  }\n}\n\n@media (max-width: 480px) {\n  .error-code {\n    font-size: 4rem;\n  }\n\n  .error-icon {\n    font-size: 8rem;\n  }\n\n  .not-found-title {\n    font-size: 1.25rem;\n  }\n}\n\n[dir='ltr'] .dropdown-toggle::after {\n    display: inline-block;\n    margin-left: .255em;\n    margin-right: 0em;\n}\n[dir='rtl'] .dropdown-toggle::after {\n    display: inline-block;\n    margin-right: .255em;\n    margin-left: 0em;\n}\n/* RTL Support */\n[dir=\"rtl\"] .btn-not-found:hover .btn-icon {\n  transform: translateX(-4px);\n}\n\n[dir=\"rtl\"] .btn-not-found:hover .btn-icon.rotate {\n  transform: translateX(4px);\n}\n\n/* Global Dark Mode Fixes for Bootstrap Components */\nbody.dark-theme .table {\n  --bs-table-bg: transparent;\n  --bs-table-color: var(--text-lighter);\n  color: var(--text-lighter) !important;\n  border-color: var(--border-color);\n}\nbody.dark-theme .table > :not(caption) > * > * {\n  background-color: transparent !important;\n  color: var(--text-lighter) !important;\n  border-bottom-color: var(--border-color) !important;\n}\nbody.dark-theme .table-striped > tbody > tr:nth-of-type(odd) > * {\n  background-color: rgba(255, 255, 255, 0.05) !important;\n  color: var(--text-lighter) !important;\n}\nbody.dark-theme .table-hover > tbody > tr:hover > * {\n  background-color: rgba(255, 255, 255, 0.1) !important;\n  color: var(--text-lighter) !important;\n}\n\n.input-div {\n  background-color: var(--input-bg) !important;\n  color: var(--sub-color) !important;\n  border: 1px solid var(--border-color) !important;\n  border-radius: 4px;\n  padding: 10px;\n  width: 100%;\n}\nbody.dark-theme .input-div {\n  color: var(--text-lighter) !important;\n}\n\nbody.dark-theme .bg-white,\nbody.dark-theme .bg-light {\n  background-color: var(--basic-color) !important;\n  color: var(--text-lighter) !important;\n  border-color: var(--border-color) !important;\n}\n\n/* React Select Dark Mode Overrides */\nbody.dark-theme .css-13cymwt-control,\nbody.dark-theme .react-select__control,\nbody.dark-theme [class*=\"-control\"] {\n  background-color: var(--input-bg) !important;\n  border-color: var(--border-color) !important;\n}\n\nbody.dark-theme .css-1dimb5e-singleValue,\nbody.dark-theme .react-select__single-value,\nbody.dark-theme [class*=\"-singleValue\"] {\n  color: var(--text-lighter) !important;\n}\n\nbody.dark-theme .css-1jqq78o-placeholder,\nbody.dark-theme .react-select__placeholder,\nbody.dark-theme [class*=\"-placeholder\"] {\n  color: #94A3B8 !important;\n}\n\nbody.dark-theme .react-select__menu,\nbody.dark-theme [class*=\"-menu\"] {\n  background-color: var(--dropdown-bg) !important;\n  border: 1px solid var(--border-color) !important;\n}\n\nbody.dark-theme .react-select__option,\nbody.dark-theme [class*=\"-option\"] {\n  background-color: transparent;\n  color: var(--text-lighter) !important;\n}\n\nbody.dark-theme .react-select__option--is-focused,\nbody.dark-theme .react-select__option:hover,\nbody.dark-theme [class*=\"-option\"][id*=\"focused\"] {\n  background-color: rgba(255, 255, 255, 0.1) !important;\n}\n\nbody.dark-theme .react-select__option--is-selected {\n  background-color: var(--green-color) !important;\n  color: #fff !important;\n}\n\nbody.dark-theme .react-select__indicator,\nbody.dark-theme [class*=\"-indicatorContainer\"] {\n  color: var(--text-lighter) !important;\n}\n\n/* Custom SearchableDropdown Dark Mode Overrides */\nbody.dark-theme [class*=\"SearchableDropdown_dropdownTrigger\"] {\n  background-color: var(--input-bg) !important;\n  border-color: var(--border-color) !important;\n}\n\nbody.dark-theme [class*=\"SearchableDropdown_selected\"] {\n  color: var(--text-lighter) !important;\n}\n\nbody.dark-theme [class*=\"SearchableDropdown_placeholder\"] {\n  color: #94A3B8 !important;\n}\n\nbody.dark-theme [class*=\"SearchableDropdown_dropdownMenu\"] {\n  background-color: var(--dropdown-bg) !important;\n  border-color: var(--border-color) !important;\n}\n\nbody.dark-theme [class*=\"SearchableDropdown_searchInput\"] {\n  background-color: var(--input-bg) !important;\n  color: var(--text-lighter) !important;\n  border-color: var(--border-color) !important;\n}\n\nbody.dark-theme [class*=\"SearchableDropdown_dropdownOption\"] {\n  border-bottom-color: var(--border-color) !important;\n  color: var(--text-lighter) !important;\n}\n\nbody.dark-theme [class*=\"SearchableDropdown_dropdownOption\"]:hover {\n  background-color: rgba(255, 255, 255, 0.1) !important;\n}\n\nbody.dark-theme [class*=\"SearchableDropdown_dropdownOptionSelected\"],\nbody.dark-theme [class*=\"SearchableDropdown_dropdownOptionSelected\"]:hover {\n  background-color: var(--green-color) !important;\n  color: #fff !important;\n}\n\nbody.dark-theme [class*=\"SearchableDropdown_dropdownSearch\"] {\n  border-bottom-color: var(--border-color) !important;\n}\n\nbody.dark-theme [class*=\"SearchableDropdown_dropdownLoading\"],\nbody.dark-theme [class*=\"SearchableDropdown_dropdownNoResults\"],\nbody.dark-theme [class*=\"SearchableDropdown_dropdownPaginationInfo\"] {\n  color: #94A3B8 !important;\n  background-color: transparent !important;\n  border-top-color: var(--border-color) !important;\n}\n\n/* Deep Project Custom Component Dark Overrides */\nbody.dark-theme .profile-container,\nbody.dark-theme .profile-form,\nbody.dark-theme .profile-card,\nbody.dark-theme .providers_on_map .input-div,\nbody.dark-theme .providers_on_map select,\nbody.dark-theme .providers_on_map input {\n  background-color: var(--basic-color) !important;\n  color: var(--text-lighter) !important;\n  border-color: var(--border-color) !important;\n}\n\nbody.dark-theme .profile-card .profile-info p {\n  color: var(--text-lighter) !important;\n}\n\n/* =========================================\n   Mobile Responsiveness Overrides\n   ========================================= */\n\n/* Tablets (max-width: 991px) */\n@media (max-width: 991px) {\n  .content_wrapper {\n    padding-inline: 15px !important;\n    margin-block: 15px !important;\n  }\n  .form-style, .table_form {\n    padding: 15px !important;\n  }\n}\n\n/* Mobile Devices (max-width: 768px) */\n@media (max-width: 768px) {\n  .content_wrapper {\n    padding-inline: 10px !important;\n    margin-block: 10px !important;\n  }\n\n  .form-style, .table_form {\n    padding: 10px !important;\n  }\n\n  /* Typography Scaling */\n  h2 { font-size: 1.5rem !important; }\n  h3 { font-size: 1.3rem !important; }\n  h4 { font-size: 1.1rem !important; }\n  .text-md { font-size: 1rem !important; }\n\n  /* Navbar Adjustments */\n  .topnav .container {\n    padding-inline: 10px;\n  }\n  \n  .topnav .actions {\n    gap: 5px;\n  }\n  \n  .topnav .actions .dropdown-toggle {\n    padding-inline: 5px;\n  }\n\n  .topnav .actions li.me-3 {\n    margin-right: 5px !important;\n  }\n\n  /* Flexible Form Alignment */\n  .form-style .d-flex {\n    flex-wrap: wrap;\n    gap: 10px;\n  }\n}\n\n/* Small Mobile Devices (max-width: 576px) */\n@media (max-width: 576px) {\n  .toggle_sidenav span {\n    padding: 8px !important;\n  }\n\n  .toggle_sidenav {\n    gap: 0.25rem !important;\n  }\n\n  /* Navbar Icons Resizing */\n  .topnav .actions li button svg {\n    font-size: 20px !important;\n  }\n\n  /* Adjust Modal padding */\n  .modal-body {\n    padding: 10px;\n  }\n\n  /* Cards */\n  .stat_card {\n    padding: 15px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
